/* eslint-disable no-loop-func */
/* eslint-disable eqeqeq */
/* eslint-disable no-new-object */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import _ from "lodash";
import moment from "moment";
import { store } from "..";
import { ADMISSION_TYPES } from "../data/admission.data";
import {
	setAdtFacilityPercentage,
	setFacilityPercentage,
	setFilterTotal,
	setFilterTotalWithoutLock,
	setIsCensusTotalLocked,
	setLockTotal,
	setLockedByFacility,
	setLockedTotalBy,
	setLockedlockeByADT,
} from "../store/reducers/admission.slice";
import {
	setAdtFacilityPercentageComparison,
	setFacilityPercentage as setFacilityPercentageComparison,
	setFilterTotal as setFilterTotalComparison,
	setFilterTotalWithoutLock as setFilterTotalWithoutLockComparison,
	setIsCensusTotalLocked as setIsCensusTotalLockedComparison,
	setLockTotal as setLockTotalComparison,
	setLockedTotalBy as setLockedTotalByComparison,
	setLockedlockeByADT as setLockedlockeByADTComparison,
	setLockedByFacility as setLockedByFacilityComparison,
} from "../store/reducers/comparisonReducers/admissionComparison.slice";
import { ADMISSION_CARDS_TYPE, ADMISSION_CARDS_LABELS, ADMISSION_FILTER_TYPE } from "../types/admission.type";
import { ADT_TABLE_TYPE, ADT_TYPES, TOTAL_TYPE, CUSTOM_TAB_TYPE } from "../types/common.type";
import { PAGE_TYPE } from "../types/pages.type";
import { dynamicCardFilter, filterCustomPatientData, filterListDataItems, getDynamicPercentageBy, itemPercentage, processDynamicCard } from "./common";
import { batch } from "react-redux";
import { getCustomTabsCards } from "./custom-tab-filter";
import { averageLengthOfStayData, daysData, doctorData, dxData, floorsData } from "./hospital-common";

// Attach level1/level2/level3/level4/level5 totals to list items for tooltip only (non-mutating calculations).
const attachLevelTotals = (list, snapshots, currentLevel, getKey, cardTitles = {}) => {
	if (!Array.isArray(list) || currentLevel < 2 || !snapshots) return list;
	const level1 = Array.isArray(snapshots.level1) ? snapshots.level1 : [];
	const level2 = Array.isArray(snapshots.level2) ? snapshots.level2 : [];
	const level3 = Array.isArray(snapshots.level3) ? snapshots.level3 : [];
	const level4 = Array.isArray(snapshots.level4) ? snapshots.level4 : [];
	const level5 = Array.isArray(snapshots.level5) ? snapshots.level5 : [];
	return list.map((item) => {
		// Preserve existing level totals if they're already set (e.g., from dxData, shiftData)
		if (item.level1Total !== undefined || item.level2Total !== undefined || item.level3Total !== undefined || item.level4Total !== undefined || item.level5Total !== undefined) {
			return {
				...item,
				...(currentLevel >= 2 && cardTitles.level1 && { level1CardTitle: cardTitles.level1 }),
				...(currentLevel >= 3 && cardTitles.level2 && { level2CardTitle: cardTitles.level2 }),
				...(currentLevel >= 4 && cardTitles.level3 && { level3CardTitle: cardTitles.level3 }),
				...(currentLevel >= 5 && cardTitles.level4 && { level4CardTitle: cardTitles.level4 }),
				...(currentLevel >= 6 && cardTitles.level5 && { level5CardTitle: cardTitles.level5 }),
			};
		}
		const key = getKey(item);
		if (key === undefined || key === null) return item;
		const level1Total = level1.filter((p) => getKey(p) === key).length;
		const level2Total = level2.filter((p) => getKey(p) === key).length;
		const level3Total = level3.filter((p) => getKey(p) === key).length;
		const level4Total = level4.filter((p) => getKey(p) === key).length;
		const level5Total = level5.filter((p) => getKey(p) === key).length;
		return {
			...item,
			...(currentLevel >= 2 && { level1Total }),
			...(currentLevel >= 3 && { level2Total }),
			...(currentLevel >= 4 && { level3Total }),
			...(currentLevel >= 5 && { level4Total }),
			...(currentLevel >= 6 && { level5Total }),
			...(currentLevel >= 2 && cardTitles.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles.level5 && { level5CardTitle: cardTitles.level5 }),
		};
	});
};

// Helper to attach level totals when result is an array; keeps original data intact.
const maybeAttachTotals = (dataArr, snapshots, currentLevel, keySelector, cardTitles = {}) => {
	if (!Array.isArray(dataArr)) return dataArr;
	return attachLevelTotals(dataArr, snapshots, currentLevel, keySelector, cardTitles);
};

// Helper function to get shift name from transferTime using customQuestionOptions
// Moved here so it can be used in attachADTLevelTotals
const getShiftNameFromCustomOptions = (time, customQuestionOptions) => {
	if (!time || !customQuestionOptions || customQuestionOptions.length === 0) {
		return null;
	}

	const format = 'HH:mm';
	const timeFormat = moment(time, 'h:mm a').format(format);
	const givenTime = moment(timeFormat, format);

	// Find which shift the time belongs to
	for (const shiftOption of customQuestionOptions) {
		const startTime = moment(shiftOption.startTime, format);
		const endTime = moment(shiftOption.endTime, format);

		// Check if time range spans midnight (e.g., 22:59 to 07:00)
		if (endTime.isBefore(startTime) || endTime.isSame(startTime)) {
			// Time range spans midnight
			if (givenTime.isSameOrAfter(startTime) || (givenTime.isSameOrBefore(endTime) && givenTime.isBefore(startTime))) {
				return shiftOption.label;
			}
		} else {
			// Normal time range (doesn't span midnight)
			if (givenTime.isSameOrAfter(startTime) && givenTime.isSameOrBefore(endTime)) {
				return shiftOption.label;
			}
		}
	}

	// If no shift matches, return the first shift as default (or null)
	return customQuestionOptions.length > 0 ? customQuestionOptions[0].label : null;
};

/** `allPagesCustomTabs` is a map: page id (e.g. hospital) -> tab definitions[] */
function normalizeAllPagesCustomTabsMap(raw) {
	if (raw && typeof raw === "object" && !Array.isArray(raw)) {
		return raw;
	}
	return {};
}

/** Resolve full custom/combine tab from patientList.allPagesCustomTabs when ADT row only has accessor + parentId */
function resolveAdtCustomTabFromAllPages(element, allPagesMap) {
	const map = normalizeAllPagesCustomTabsMap(allPagesMap);
	if (!element?.accessor || !element?.parentId) return null;
	const pageTabs = map[element.parentId];
	if (!Array.isArray(pageTabs)) return null;
	return pageTabs.find((t) => t?.accessor === element.accessor) ?? null;
}

function attachResolvedCustomTabToAdtRow(ele, tableData, allPagesMap) {
	if (ele?.customTab?.type) {
		return { ...ele, tableData };
	}
	const resolved = resolveAdtCustomTabFromAllPages(ele, allPagesMap);
	return resolved ? { ...ele, tableData, customTab: resolved } : { ...ele, tableData };
}

/** ADT cross-dashboard data from getADTAllData (transfer-scoped); fall back to admission get-all-count payload. */
function resolveAdtDiffDashboardPatients(typeData) {
	const adtScoped = typeData?.customDiffrentDashboardData;
	const admissionScoped = typeData?.diffDashboardPatients ?? {};
	if (adtScoped == null) return admissionScoped;
	const hasListData = Object.values(adtScoped).some((entry) => {
		if (Array.isArray(entry)) return entry.length > 0;
		return (entry?.list?.length ?? 0) > 0;
	});
	return hasListData ? adtScoped : admissionScoped;
}

function isAdtCustomTabRow(element, type) {
	if (type !== ADT_TABLE_TYPE.CUSTOM) return false;
	const tabDef = element?.question?.customTab || element?.customTab;
	return (
		tabDef?.type === CUSTOM_TAB_TYPE.combineTab ||
		tabDef?.type === CUSTOM_TAB_TYPE.customTab
	);
}

const normalizeAdmissionIdStr = (id) => {
	if (id == null || id === "") return null;
	const s = String(id).trim();
	return s && s !== "undefined" && s !== "null" ? s : null;
};

/** Map ADT transfer row ids → admission ids for custom/combine tab chart filters */
const buildTransferToAdmissionLookup = (transferList, admissionPatientList = []) => {
	const transferToAdmission = new Map();
	for (const row of transferList || []) {
		const tid = normalizeAdmissionIdStr(row?.id ?? row?._id);
		const aid = normalizeAdmissionIdStr(row?.admissionId);
		if (tid && aid) transferToAdmission.set(tid, aid);
	}
	const admissionIds = new Set(
		(admissionPatientList || [])
			.map((p) => normalizeAdmissionIdStr(p?.id ?? p?._id))
			.filter(Boolean)
	);
	return { transferToAdmission, admissionIds };
};

const resolvePatientIdsToAdmissionIds = (patientIds, lookup) => {
	const { transferToAdmission, admissionIds } = lookup;
	const out = [];
	for (const raw of patientIds || []) {
		const pid = normalizeAdmissionIdStr(raw);
		if (!pid) continue;
		if (transferToAdmission.has(pid)) {
			out.push(transferToAdmission.get(pid));
		} else if (admissionIds.has(pid)) {
			out.push(pid);
		}
	}
	return _.uniq(out.filter(Boolean));
};

/** getCustomTabsCards rows only expose patientIds; ADT TableADT expects admissionIds for savedData */
const enrichAdtCustomCombineTableRowsWithAdmissionIds = (rows, transferList, admissionPatientList) => {
	if (!Array.isArray(rows) || rows.length === 0) return rows;
	const lookup = buildTransferToAdmissionLookup(transferList, admissionPatientList);
	return rows.map((row) => {
		const admissionIds = resolvePatientIdsToAdmissionIds(row?.patientIds, lookup);
		let totalByPage = row?.totalByPage;
		if (totalByPage && typeof totalByPage === "object") {
			totalByPage = { ...totalByPage };
			for (const key of Object.keys(totalByPage)) {
				const slice = totalByPage[key];
				if (slice && typeof slice === "object") {
					const sliceAdmissionIds = resolvePatientIdsToAdmissionIds(slice.patientIds, lookup);
					totalByPage[key] = {
						...slice,
						admissionIds: sliceAdmissionIds.length ? sliceAdmissionIds : slice.admissionIds,
					};
				}
			}
		}
		return {
			...row,
			...(totalByPage ? { totalByPage } : {}),
			admissionIds: admissionIds.length ? admissionIds : row?.admissionIds,
		};
	});
};

/** Resolve admission Mongo ids for ADT custom/combine priority when ids[] was empty at toggle time */
const resolveAdtCustomCombineAdmissionIdsForPriority = (
	adtEntry,
	{ transferList = [], admissionPatientList = [], adtCardList = [] } = {}
) => {
	if (!adtEntry) return [];
	const lookup = buildTransferToAdmissionLookup(transferList, admissionPatientList);
	const selectedIds = new Set((adtEntry?.selectedIds || []).map((x) => String(x)));
	const accessor = adtEntry?.accessor || adtEntry?.question?.accessor;
	const card =
		_.find(adtCardList, (c) => c.childId === adtEntry.childId && c.cardId === adtEntry.cardId) ||
		_.find(adtCardList, (c) => String(c?.id) === String(adtEntry?.id));
	const tableData = card?.tableData ?? adtEntry?.tableData ?? [];
	const fromTable = [];

	for (const row of tableData) {
		const rowId = String(row?.id ?? row?._id ?? "");
		const isCombineRow =
			row?.totalByPage && typeof row.totalByPage === "object" && Object.keys(row.totalByPage).length > 0;

		if (isCombineRow && accessor) {
			const accPrefix = `${accessor}__`;
			for (const [sliceKey, slice] of Object.entries(row.totalByPage)) {
				const composite = `${accessor}__${sliceKey}`;
				const sliceSelected =
					selectedIds.has(composite) ||
					selectedIds.has(sliceKey) ||
					selectedIds.has(rowId);
				if (!sliceSelected) continue;
				const sliceIds =
					Array.isArray(slice?.admissionIds) && slice.admissionIds.length
						? slice.admissionIds
						: slice?.patientIds;
				fromTable.push(...resolvePatientIdsToAdmissionIds(sliceIds, lookup));
			}
			if (selectedIds.has(rowId)) {
				fromTable.push(...(row?.admissionIds || []).map(String));
			}
		} else if (selectedIds.has(rowId)) {
			if (Array.isArray(row?.admissionIds) && row.admissionIds.length) {
				fromTable.push(...row.admissionIds.map(String));
			} else {
				fromTable.push(...resolvePatientIdsToAdmissionIds(row?.patientIds, lookup));
			}
		}
	}

	if (fromTable.length) {
		return _.uniq(fromTable.filter(Boolean));
	}

	const fromEntryAdmissionIds = (adtEntry?.admissionIds || [])
		.map((id) => String(id))
		.filter(Boolean);
	if (fromEntryAdmissionIds.length) {
		return _.uniq(fromEntryAdmissionIds);
	}

	const fromEntryPatientIds = resolvePatientIdsToAdmissionIds(adtEntry?.patientIds, lookup);
	if (fromEntryPatientIds.length) {
		return _.uniq(fromEntryPatientIds);
	}

	const fromTransfers = resolvePatientIdsToAdmissionIds(adtEntry?.transferIds, lookup);
	if (fromTransfers.length) {
		return fromTransfers;
	}

	return resolvePatientIdsToAdmissionIds(adtEntry?.ids, lookup);
};

// Attach level totals for ADT data (works with transferIds and relation matching)
const attachADTLevelTotals = (list, snapshots, currentLevel, cardTitles = {}) => {
	// Check if we have card titles to attach (even for first filter)
	const hasCardTitles = cardTitles && typeof cardTitles === 'object' && (
		cardTitles.level1 || cardTitles.level2 || cardTitles.level3 || cardTitles.level4 || cardTitles.level5
	);

	// If no list, no snapshots, or currentLevel < 2, we can still attach card titles if they exist
	if (!Array.isArray(list)) {
		return list;
	}

	// If we only have card titles but no snapshots/level totals, just attach card titles
	if ((currentLevel < 2 || !snapshots || typeof snapshots !== 'object') && hasCardTitles) {
		return list.map((item) => {
			const result = {
				...item,
				...(cardTitles.level1 && { level1CardTitle: cardTitles.level1 }),
				...(cardTitles.level2 && { level2CardTitle: cardTitles.level2 }),
				...(cardTitles.level3 && { level3CardTitle: cardTitles.level3 }),
				...(cardTitles.level4 && { level4CardTitle: cardTitles.level4 }),
				...(cardTitles.level5 && { level5CardTitle: cardTitles.level5 }),
			};
			return result;
		});
	}

	// If no snapshots or currentLevel < 2 and no card titles, return as-is
	if (currentLevel < 2 || !snapshots || typeof snapshots !== 'object') {
		return list;
	}

	const level1 = Array.isArray(snapshots.level1) ? snapshots.level1 : [];
	const level2 = Array.isArray(snapshots.level2) ? snapshots.level2 : [];
	const level3 = Array.isArray(snapshots.level3) ? snapshots.level3 : [];
	const level4 = Array.isArray(snapshots.level4) ? snapshots.level4 : [];
	const level5 = Array.isArray(snapshots.level5) ? snapshots.level5 : [];

	return list.map((item, index) => {
		// Always calculate level totals (don't skip if already set, as they might be wrong)

		// For ADT data, we need to match differently based on the item type
		const itemId = item._id || item.id;
		const itemElement = item.element;
		const relationKey = itemElement?.relation; // e.g., "doctor", "diagnosis"

		let level1Total = 0;
		let level2Total = 0;
		let level3Total = 0;
		let level4Total = 0;
		let level5Total = 0;

		// Check if this is TOTAL or ALL type (needs special handling by transferType)
		// Check both item.type and itemElement.type for compatibility
		const itemType = item.type || itemElement?.type;
		const isTotalType = itemType === ADT_TABLE_TYPE.TOTAL || itemType === ADT_TABLE_TYPE.ALL;
		// For TOTAL type, element.id is the transferType (e.g., "plannedHospitalTransfer")
		// For ALL type, we don't need transferTypeValue
		const transferTypeValue = itemElement?.id || itemId;


		if (isTotalType) {
			// For TOTAL/ALL type, recalculate count in each snapshot
			if (itemType === ADT_TABLE_TYPE.TOTAL && transferTypeValue) {
				// Filter by transferType in each snapshot
				// Make sure we have valid snapshot data
				if (Array.isArray(level1) && level1.length > 0) {
					level1Total = level1.filter((p) => p && p.transferType === transferTypeValue).length;
				}
				if (Array.isArray(level2) && level2.length > 0) {
					level2Total = level2.filter((p) => p && p.transferType === transferTypeValue).length;
				}
				if (Array.isArray(level3) && level3.length > 0) {
					level3Total = level3.filter((p) => p && p.transferType === transferTypeValue).length;
				}
				if (Array.isArray(level4) && level4.length > 0) {
					level4Total = level4.filter((p) => p && p.transferType === transferTypeValue).length;
				}
				if (Array.isArray(level5) && level5.length > 0) {
					level5Total = level5.filter((p) => p && p.transferType === transferTypeValue).length;
				}
			} else if (itemType === ADT_TABLE_TYPE.ALL) {
				// For ALL type, count all transfers in each snapshot
				level1Total = Array.isArray(level1) ? level1.length : 0;
				level2Total = Array.isArray(level2) ? level2.length : 0;
				level3Total = Array.isArray(level3) ? level3.length : 0;
				level4Total = Array.isArray(level4) ? level4.length : 0;
				level5Total = Array.isArray(level5) ? level5.length : 0;
			}
		} else {
			// Check if this is ANALYSIS_CHART type (time period data like 0-30 days, 31-60 days, etc.)
			const isAnalysisChart = itemType === ADT_TABLE_TYPE.ANALYSIS_CHART || itemElement?.type === ADT_TABLE_TYPE.ANALYSIS_CHART;

			if (isAnalysisChart) {
				// For ANALYSIS_CHART type, match by transferIds array (original IDs from listData)
				// The item.transferIds contains all transfer IDs that fall into this time period
				// We count how many of those transfers exist in each snapshot
				const itemIds = Array.isArray(item.transferIds) ? item.transferIds : (Array.isArray(item.ids) ? item.ids : []);

				if (itemIds.length > 0) {
					// Match by transferIds array - count how many snapshot transfers match the item's transferIds
					level1Total = level1.filter((p) => {
						const transferId = p.id || p._id;
						return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
					}).length;
					level2Total = level2.filter((p) => {
						const transferId = p.id || p._id;
						return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
					}).length;
					level3Total = level3.filter((p) => {
						const transferId = p.id || p._id;
						return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
					}).length;
					level4Total = level4.filter((p) => {
						const transferId = p.id || p._id;
						return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
					}).length;
					level5Total = level5.filter((p) => {
						const transferId = p.id || p._id;
						return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
					}).length;
				}
			} else {
				// Check if this is GROUP_ARRAY type (nested arrays like diagnoses)
				const isGroupArray = itemElement?.type === ADT_TABLE_TYPE.GROUP_ARRAY;
				const elementId = itemElement?.id; // e.g., "diagnoses", "diagnosis"

				if (isGroupArray && elementId && itemId) {
					// For GROUP_ARRAY type, we need to extract nested arrays from each snapshot and group by _id
					// This matches how getADTGroupArrayData processes the data
					const processGroupArrayForLevel = (snapshotData) => {
						if (!Array.isArray(snapshotData) || snapshotData.length === 0) return {};
						let nestedArrayItems = [];
						snapshotData.forEach((ele) => {
							if (ele[elementId] && Array.isArray(ele[elementId]) && ele[elementId].length > 0) {
								// Extract nested array items (like diagnoses) and add admissionId/patientId for tracking
								const nestedItems = ele[elementId].map((obj) => ({
									...obj,
									admissionId: ele.admissionId,
									patientId: ele.id
								}));
								nestedArrayItems = [...nestedItems, ...nestedArrayItems];
							}
						});
						// Group by _id (matching getADTGroupArrayData logic)
						return _.groupBy(nestedArrayItems, "_id");
					};

					const groupLevel1 = processGroupArrayForLevel(level1);
					const groupLevel2 = processGroupArrayForLevel(level2);
					const groupLevel3 = processGroupArrayForLevel(level3);
					const groupLevel4 = processGroupArrayForLevel(level4);
					const groupLevel5 = processGroupArrayForLevel(level5);

					// Count items in the group matching itemId
					level1Total = Array.isArray(groupLevel1[itemId]) ? groupLevel1[itemId].length : 0;
					level2Total = Array.isArray(groupLevel2[itemId]) ? groupLevel2[itemId].length : 0;
					level3Total = Array.isArray(groupLevel3[itemId]) ? groupLevel3[itemId].length : 0;
					level4Total = Array.isArray(groupLevel4[itemId]) ? groupLevel4[itemId].length : 0;
					level5Total = Array.isArray(groupLevel5[itemId]) ? groupLevel5[itemId].length : 0;
				} else if (relationKey && itemId) {
					// For group data (GROUP type), match by relation ID in the snapshot
					// Follow the same pattern as getADTGroupData: extract relationId from arrayLabelData[element.relation]["_id"]
					// itemId comes from relationIdLet = arrayLabelData[element.relation]["_id"] (line 852 in getADTGroupData)
					// So we need to match: p[relationKey]["_id"] === itemId
					const itemIdStr = String(itemId); // Convert to string for consistent comparison

					// Helper function to match exactly like getADTGroupData extracts the relation ID
					const matchesRelation = (p) => {
						if (!p) return false;
						// Extract relation object the same way as getADTGroupData: arrayLabelData[element.relation]
						const relationObj = p[relationKey];
						if (!relationObj) return false;

						// Match exactly like getADTGroupData: arrayLabelData[element.relation]["_id"]
						// Check both _id and id for compatibility, but prioritize _id (as used in getADTGroupData)
						if (typeof relationObj === 'object' && relationObj !== null && !Array.isArray(relationObj)) {
							const relationId = relationObj._id ?? relationObj.id;
							if (relationId !== undefined && relationId !== null) {
								return String(relationId) === itemIdStr;
							}
						}
						// If relationObj is a string, compare directly
						if (typeof relationObj === 'string') {
							return String(relationObj) === itemIdStr;
						}
						return false;
					};

					const level1Matches = level1.filter(matchesRelation);
					level1Total = level1Matches.length;
					level2Total = level2.filter(matchesRelation).length;
					level3Total = level3.filter(matchesRelation).length;
					level4Total = level4.filter(matchesRelation).length;
					level5Total = level5.filter(matchesRelation).length;

				} else {
					// For non-group data (chart data, etc.), we need to recalculate the category in each snapshot
					// For chart data, the item represents a category (like shift name, day, etc.)
					// We need to group the snapshot by the same criteria and count records in that category
					const itemElement = item.element;
					const elementId = itemElement?.id; // e.g., "shiftName", "day", etc.
					const itemFilterId = item.filterId; // The filterId used for grouping
					const customQuestionOptions = itemElement?.customQuestionOptions;

					// If we have element information, recalculate the category count in each snapshot
					if (elementId && (itemFilterId !== undefined || itemId)) {
						// For shift data with customQuestionOptions, we need to recalculate shifts in each snapshot
						if (elementId === "shiftName" && customQuestionOptions && customQuestionOptions.length > 0) {
							// Recalculate shifts for each snapshot level
							const calculateShiftsForLevel = (snapshotData) => {
								if (!Array.isArray(snapshotData) || snapshotData.length === 0) return {};
								const dataWithShift = snapshotData.map(p => ({
									...p,
									calculatedShift: getShiftNameFromCustomOptions(p.transferTime, customQuestionOptions) || (customQuestionOptions?.[0]?.label || null)
								}));
								return _.groupBy(dataWithShift, "calculatedShift");
							};

							const groupLevel1 = calculateShiftsForLevel(level1);
							const groupLevel2 = calculateShiftsForLevel(level2);
							const groupLevel3 = calculateShiftsForLevel(level3);
							const groupLevel4 = calculateShiftsForLevel(level4);
							const groupLevel5 = calculateShiftsForLevel(level5);

							// Use filterId (shift label) to find the group
							const categoryKey = itemFilterId !== undefined ? itemFilterId : itemId;

							level1Total = Array.isArray(groupLevel1[categoryKey]) ? groupLevel1[categoryKey].length : 0;
							level2Total = Array.isArray(groupLevel2[categoryKey]) ? groupLevel2[categoryKey].length : 0;
							level3Total = Array.isArray(groupLevel3[categoryKey]) ? groupLevel3[categoryKey].length : 0;
							level4Total = Array.isArray(groupLevel4[categoryKey]) ? groupLevel4[categoryKey].length : 0;
							level5Total = Array.isArray(groupLevel5[categoryKey]) ? groupLevel5[categoryKey].length : 0;
						} else {
							// For other chart data, group by element.id directly
							const groupLevel1 = _.groupBy(level1, elementId);
							const groupLevel2 = _.groupBy(level2, elementId);
							const groupLevel3 = _.groupBy(level3, elementId);
							const groupLevel4 = _.groupBy(level4, elementId);
							const groupLevel5 = _.groupBy(level5, elementId);

							// Use filterId if available, otherwise use itemId
							const categoryKey = itemFilterId !== undefined ? itemFilterId : itemId;

							level1Total = Array.isArray(groupLevel1[categoryKey]) ? groupLevel1[categoryKey].length : 0;
							level2Total = Array.isArray(groupLevel2[categoryKey]) ? groupLevel2[categoryKey].length : 0;
							level3Total = Array.isArray(groupLevel3[categoryKey]) ? groupLevel3[categoryKey].length : 0;
							level4Total = Array.isArray(groupLevel4[categoryKey]) ? groupLevel4[categoryKey].length : 0;
							level5Total = Array.isArray(groupLevel5[categoryKey]) ? groupLevel5[categoryKey].length : 0;
						}
					} else {
						// Fallback to transferIds matching for items without element info
						const itemIds = Array.isArray(item.transferIds) ? item.transferIds : (Array.isArray(item.ids) ? item.ids : []);

						if (!itemIds.length && itemId) {
							// Single ID matching
							level1Total = level1.filter((p) => p.id === itemId || p._id === itemId).length;
							level2Total = level2.filter((p) => p.id === itemId || p._id === itemId).length;
							level3Total = level3.filter((p) => p.id === itemId || p._id === itemId).length;
							level4Total = level4.filter((p) => p.id === itemId || p._id === itemId).length;
							level5Total = level5.filter((p) => p.id === itemId || p._id === itemId).length;
						} else if (itemIds.length > 0) {
							// Match by transferIds array
							level1Total = level1.filter((p) => {
								const transferId = p.id || p._id;
								return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
							}).length;
							level2Total = level2.filter((p) => {
								const transferId = p.id || p._id;
								return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
							}).length;
							level3Total = level3.filter((p) => {
								const transferId = p.id || p._id;
								return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
							}).length;
							level4Total = level4.filter((p) => {
								const transferId = p.id || p._id;
								return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
							}).length;
							level5Total = level5.filter((p) => {
								const transferId = p.id || p._id;
								return transferId !== undefined && transferId !== null && itemIds.includes(transferId);
							}).length;
						}
					}
				}
			}
		}

		const result = {
			...item,
			...(currentLevel >= 2 && { level1Total }),
			...(currentLevel >= 3 && { level2Total }),
			...(currentLevel >= 4 && { level3Total }),
			...(currentLevel >= 5 && { level4Total }),
			...(currentLevel >= 6 && { level5Total }),
			...(currentLevel >= 2 && cardTitles.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles.level5 && { level5CardTitle: cardTitles.level5 }),
		};

		return result;
	});
};

export const updateADTChartFilter = async (cardFilter, selectedCardItem) => {
	// ADT details dialog: keep prior ADT tab filters (custom/combine, etc.) but not the card being opened.
	const adtAdmitPatientIds = (cardFilter?.adtAdmitPatientIds || []).filter(
		(e) =>
			!(
				e?.childId === selectedCardItem?.childId &&
				e?.cardId === selectedCardItem?.cardId
			)
	);
	return {
		..._.omit(cardFilter, ["mainPriorityData"]),
		adtAdmitPatientIds,
	};
};

export const updateAdmissionChartFilter = async (cardFilter, type, adtResolveContext = null) => {
	let latestCardFilter = cardFilter;
	/** ADT priority entry → admission Mongo ids for getCardPatientChartData (ADTFilter). */
	const resolveAdtAdmissionIds = (element) => {
		if (!element || element.filterType !== ADMISSION_FILTER_TYPE.ADT) {
			return element?.ids || [];
		}

		const directAdmission = (element?.admissionIds || [])
			.map((id) => String(id))
			.filter(Boolean);
		if (directAdmission.length) {
			return _.uniq(directAdmission);
		}

		let ids = (element?.ids || []).map((id) => String(id)).filter(Boolean);
		if (adtResolveContext) {
			const lookup = buildTransferToAdmissionLookup(
				adtResolveContext.transferList,
				adtResolveContext.admissionPatientList
			);
			const fromMapped = resolvePatientIdsToAdmissionIds(ids, lookup);
			if (fromMapped.length) {
				return fromMapped;
			}
			if (
				element?.type === ADT_TABLE_TYPE.CUSTOM ||
				element?.accessor ||
				element?.customQuestionInputType
			) {
				const resolved = resolveAdtCustomCombineAdmissionIdsForPriority(element, adtResolveContext);
				if (resolved.length) {
					return resolved;
				}
			}
		}

		return ids;
	};
	const selectedPriority = _.find(cardFilter.mainPriorityData, { type: type });
	if (selectedPriority) {
		let idx = cardFilter.mainPriorityData.findIndex((elem) => elem.type === type);
		if (idx !== -1) {
			let selectedCardPriority = [];
			let selectedFilters = [];
			let updatedFilter = Object();
			if (cardFilter.mainPriorityData.length > 1) {
				selectedCardPriority = cardFilter.mainPriorityData.slice(0, idx);
				selectedFilters = _.map(selectedCardPriority, "type");
				let alreadySaved = false;
				selectedCardPriority
					.slice(0)
					.reverse()
					.map((element) => {
						if (element.filterType === ADMISSION_FILTER_TYPE.ADT && !alreadySaved) {
							alreadySaved = true;
							updatedFilter["admissionsIds"] = resolveAdtAdmissionIds(element);
							updatedFilter["ADTFilter"] = true;
						}
					});
			}
			for await (const [key, value] of Object.entries(cardFilter)) {
				if (_.includes(selectedFilters, key)) {
					updatedFilter[key] = value;
				} else {
					updatedFilter[key] = [];
				}
			}
			latestCardFilter = updatedFilter;
		}
	} else {
		if (cardFilter.mainPriorityData.length > 0) {
			let adtPriorityData = _.filter(cardFilter.mainPriorityData, { filterType: ADMISSION_FILTER_TYPE.ADT });
			if (adtPriorityData.length > 0) {
				let lastElement = adtPriorityData.slice(-1);
				if (lastElement.length > 0) {
					latestCardFilter = Object.assign({}, latestCardFilter, {
						admissionsIds: resolveAdtAdmissionIds(lastElement[0]),
						ADTFilter: true,
					});
				}
			}
		}
	}
	return latestCardFilter
};

export async function plannedFilter(patientData, oldFilter, type = null) {
	patientData = _.filter(patientData, ({ floorId, doctorId, dxIds, day, hospitalId, insuranceId }) => {
		let filterArr = [];

		if (oldFilter.insuranceData.length > 0 && type !== "insuranceData") {
			filterArr.push(_.includes(oldFilter.insuranceData, insuranceId));
		}
		if (oldFilter.floorsData.length > 0 && type !== "floorsData") {
			filterArr.push(_.includes(oldFilter.floorsData, floorId));
		}
		if (oldFilter.daysData.length > 0 && type !== "daysData") {
			filterArr.push(_.includes(oldFilter.daysData, day));
		}
		if (oldFilter.doctorData.length > 0 && type !== "doctorData") {
			filterArr.push(_.includes(oldFilter.doctorData, doctorId));
		}
		if (oldFilter.hospitalData.length > 0 && type !== "hospitalData") {
			filterArr.push(_.includes(oldFilter.hospitalData, hospitalId));
		}
		if (oldFilter.dxData.length > 0 && type !== "dxData") {
			filterArr.push(_.isEqual(_.intersection(oldFilter.dxData, dxIds), dxIds));
		}
		return _.every(filterArr);
	});
	return patientData;
}

async function hospitalListData(data, totalFilterData, filter, projectionDays, shouldCalcProj) {
	//insuranceData Cal
	let hospitalDBDataGroup = [];
	if (data && data.length > 0) {
		const hospitalDBData = _.groupBy(data, "hospitalId");
		const originalData = _.groupBy(totalFilterData.originalData, "hospitalId");
		if (hospitalDBData) {
			let percentageTotal = totalFilterData.totalForPercentage ? totalFilterData.totalForPercentage : data?.length;

			hospitalDBDataGroup = await filterListDataItems(hospitalDBData, "hospital", percentageTotal, {
				...totalFilterData,
				originalData,
			});
		}
	}
	return hospitalDBDataGroup;
}

export async function insuranceData(data, totalFilterData) {
	//insuranceData Cal
	let insuranceDBDataGroup = [];
	if (data && data.length > 0) {
		const insuranceDBData = _.groupBy(data, "insuranceId");
		if (insuranceDBData) {
			const originalData = _.groupBy(totalFilterData.originalData, "insuranceId");
			let percentageTotal = totalFilterData.totalForPercentage ? totalFilterData.totalForPercentage : data?.length;

			insuranceDBDataGroup = await filterListDataItems(insuranceDBData, "payerSourceInsurance", percentageTotal, {
				...totalFilterData,
				originalData,
				groupByKey: "insuranceId",
			});
		}
	}

	return insuranceDBDataGroup;
}

//All ADT TAB FUNCTIONS HERE
async function getADTTotalData(
	element,
	patientList,
	adtTotal,
	type = "transferType",
	{ totalType = null, isTooltip = false, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = {}
) {
	let filtersArray = [];
	const eleID = element.id;
	const eleLabel = element.label;
	let findData = [];
	if (type === "transferType") {
		findData = _.filter(patientList, { transferType: eleID });
	} else {
		findData = patientList;
	}
	const total = findData.length || 0;
	let originalTotal = total;
	if (totalType == TOTAL_TYPE.FILTER) {
		const tableData = element.tableData ? element.tableData : [];
		const findTableData = _.find(tableData, { _id: eleID });
		originalTotal = findTableData?.originalTotal || 0;
	}
	const object = {
		id: eleID,
		_id: eleID,
		label: eleLabel,
		name: eleLabel,
		total,
		originalTotal,
		isTooltip,
		admissionIds: _.map(findData, "admissionId"),
		transferIds: _.map(findData, "id"),
		percentage: itemPercentage(total, adtTotal, "number"),
		type: element.type, // This should be ADT_TABLE_TYPE.TOTAL or ADT_TABLE_TYPE.ALL
		element: {
			...element,
			type: element.type, // Ensure type is set correctly
		},
	};
	filtersArray.push(object);

	// Attach level totals during data creation (matching admission page pattern)
	// Also attach card titles even for first filter (currentLevel = 1) if card titles are available
	const hasCardTitles = cardTitles && typeof cardTitles === 'object' && (
		cardTitles.level1 || cardTitles.level2 || cardTitles.level3 || cardTitles.level4 || cardTitles.level5
	);
	if (Array.isArray(filtersArray) && filtersArray.length > 0 &&
		((currentLevel >= 2 && intermediateTotals && Object.keys(intermediateTotals).length > 0) || hasCardTitles)) {
		filtersArray = attachADTLevelTotals(filtersArray, intermediateTotals || {}, currentLevel, cardTitles);
	}

	return filtersArray;
}

export function matchedArray(array1, array2) {
	return _.intersectionWith(array1, array2, _.isEqual);
}

async function ninetyDaysDataList(listData, element, patients, adtTotal, { totalType = null, isTooltip = false, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = {}) {
	const matchedIds = patients.length > 0 ? patients.map((item) => item.id) : [];
	const matchedAdmissionIds = patients.length > 0 ? patients.map((item) => item.admissionId) : [];

	if (listData && listData.length > 0) {
		const latestData = listData.map((item) => {
			const intersection = matchedArray(matchedIds, item.ids);
			const intersectionAdmission = matchedArray(matchedAdmissionIds, item.admissionIds);
			const total = intersection.length;
			let originalTotal = total;
			if (totalType == TOTAL_TYPE.FILTER) {
				const tableData = element.tableData ? element.tableData : [];
				const findTableData = _.find(tableData, { _id: item._id });
				originalTotal = findTableData?.originalTotal || 0;
			}
			// For level totals, use original item.ids (all transfers in this time period)
			// not just the filtered intersection, so we can match against snapshots correctly
			const originalTransferIds = Array.isArray(item.ids) ? item.ids : [];
			let obj = {
				id: item._id,
				name: item.label,
				_id: item._id,
				label: item.label,
				total: total || 0,
				ids: intersection, // Current filtered IDs for display
				transferIds: originalTransferIds, // Original IDs for level totals matching
				originalTotal,
				isTooltip,
				patientIds: intersection,
				percentage: itemPercentage(total, adtTotal, "number", PAGE_TYPE.ADMISSION),
				type: element.type,
				element: element,
				admissionIds: intersectionAdmission,
			};
			return Object.assign({}, item, obj);
		});

		// Attach level totals during data creation (matching admission page pattern)
		if (currentLevel >= 2 && Array.isArray(latestData) && latestData.length > 0 && intermediateTotals && Object.keys(intermediateTotals).length > 0) {
			return attachADTLevelTotals(latestData, intermediateTotals, currentLevel, cardTitles);
		}

		return latestData;
	}
	return [];
}

async function getADTAnalysisChartData(element, patientList, transferPatientList, adtTotal, typeData = {}) {
	const { totalType = null, isTooltip = false, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = typeData;
	let chartArray = element.arrayName ? patientList[element.arrayName] : [];
	const latest90Days = ninetyDaysDataList(chartArray, element, transferPatientList, adtTotal, { totalType, isTooltip, intermediateTotals, currentLevel, cardTitles });
	return latest90Days;
}

async function getADTChartDaysData(element, patientList, adtTotal, { totalType = null, isTooltip = false, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = {}) {
	let chartADTData = [];
	const groupByChartData = await _.groupBy(patientList, element.id);
	const chartLabels = element.chartsLabel || [];

	for await (const item of chartLabels) {
		//chartLabels.filter((item) => {
		const chartLabelItem = groupByChartData[item.filterId];
		const patientIds = await _.map(chartLabelItem, "admissionId");
		const transferIds = await _.map(chartLabelItem, "id");
		const total = chartLabelItem?.length || 0;
		let originalTotal = total;
		if (totalType == TOTAL_TYPE.FILTER) {
			const tableData = element.tableData ? element.tableData : [];
			const findTableData = _.find(tableData, { _id: item.id });
			originalTotal = findTableData?.originalTotal || 0;
		}
		let object = {
			id: item.id,
			filterId: item.filterId,
			name: item.label,
			_id: item.id,
			label: item.label,
			total,
			patientIds,
			ids: transferIds, // Use transferIds for ids (not patientIds/admissionIds)
			admissionIds: patientIds,
			transferIds: transferIds, // Ensure transferIds is set for level totals matching
			originalTotal,
			isTooltip,
			percentage: await itemPercentage(total, adtTotal, "number", PAGE_TYPE.ADMISSION),
			type: element.type,
			element: element,
			chartsLabel: element.chartsLabel,
		};
		chartADTData.push(object);
	}

	// Attach level totals during data creation (matching admission page pattern)
	if (currentLevel >= 2 && Array.isArray(chartADTData) && chartADTData.length > 0 && intermediateTotals && Object.keys(intermediateTotals).length > 0) {
		chartADTData = attachADTLevelTotals(chartADTData, intermediateTotals, currentLevel, cardTitles);
	}

	return chartADTData;
}

async function getADTChartData(element, patientList, adtTotal, { totalType = null, isTooltip = false, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = {}) {
	let chartADTData = [];

	// check why the percentage is different
	const groupByChartData = _.groupBy(patientList, element.id);
	let chartLabels = element.chartsLabel || [];
	if (element.id === "shiftName" && element.customQuestionOptions?.length > 0) {
		const customQuestionOptions = element.customQuestionOptions;

		// Calculate shift from transferTime using customQuestionOptions (similar to shiftData in hospital-common.js)
		const patientListWithShift = patientList.map(item => ({
			...item,
			calculatedShift: getShiftNameFromCustomOptions(item.transferTime, customQuestionOptions) || (customQuestionOptions?.[0]?.label || null)
		}));

		// Group by calculated shift
		const groupByCalculatedShift = _.groupBy(patientListWithShift, "calculatedShift");
		const shiftDBData = _.countBy(patientListWithShift, "calculatedShift");

		// Get original data counts from tableData if available
		let originalDataGroupBy = {};
		if (totalType == TOTAL_TYPE.FILTER && element.tableData) {
			// If we have tableData, we can extract originalTotal from there
			originalDataGroupBy = {};
			customQuestionOptions.forEach(shiftOption => {
				const findTableData = _.find(element.tableData, { _id: shiftOption.label });
				if (findTableData) {
					originalDataGroupBy[shiftOption.label] = findTableData.originalTotal || 0;
				}
			});
		}

		// Build chart data array dynamically from customQuestionOptions (similar to else part structure)
		for await (const shiftOption of customQuestionOptions) {
			const shiftLabel = shiftOption.label;
			const chartLabelItem = groupByCalculatedShift[shiftLabel] || [];
			const admissionIds = _.map(chartLabelItem, "admissionId");
			const transferIds = _.map(chartLabelItem, "id");
			const total = shiftDBData?.[shiftLabel] || 0;
			let originalTotal = total;

			if (totalType == TOTAL_TYPE.FILTER) {
				if (originalDataGroupBy[shiftLabel] !== undefined) {
					originalTotal = originalDataGroupBy[shiftLabel];
				} else {
					const tableData = element.tableData ? element.tableData : [];
					const findTableData = _.find(tableData, { _id: shiftLabel });
					originalTotal = findTableData?.originalTotal || 0;
				}
			}

			let object = {
				id: shiftLabel,
				filterId: shiftLabel,
				name: shiftLabel,
				_id: shiftLabel,
				label: shiftLabel,
				total,
				ids: transferIds,
				transferIds: transferIds, // Add transferIds for level totals matching
				originalTotal,
				isTooltip,
				patientIds: transferIds,
				admissionIds: admissionIds,
				percentage: itemPercentage(total, adtTotal, "number", PAGE_TYPE.ADMISSION),
				type: element.type,
				element: element,
			};
			chartADTData.push(object);
		}
	} else {
		for await (const item of chartLabels) {
			const chartLabelItem = groupByChartData[item.filterId];
			const admissionIds = _.map(chartLabelItem, "admissionId");
			const transferIds = _.map(chartLabelItem, "id");
			const total = chartLabelItem?.length || 0;
			let originalTotal = total;
			if (totalType == TOTAL_TYPE.FILTER) {
				const tableData = element.tableData ? element.tableData : [];
				const findTableData = _.find(tableData, { _id: item.id });
				originalTotal = findTableData?.originalTotal || 0;
			}
			let object = {
				id: item.id,
				filterId: item.filterId,
				name: item.label,
				_id: item.id,
				label: item.label,
				total,
				ids: transferIds,
				transferIds: transferIds, // Add transferIds for level totals matching
				originalTotal,
				isTooltip,
				patientIds: transferIds,
				admissionIds: admissionIds,
				percentage: itemPercentage(total, adtTotal, "number", PAGE_TYPE.ADMISSION),
				type: element.type,
				element: element,
			};
			chartADTData.push(object);
		}
	}

	// Attach level totals during data creation (matching admission page pattern)
	if (currentLevel >= 2 && Array.isArray(chartADTData) && chartADTData.length > 0 && intermediateTotals && Object.keys(intermediateTotals).length > 0) {
		chartADTData = attachADTLevelTotals(chartADTData, intermediateTotals, currentLevel, cardTitles);
	}

	return chartADTData;
}

async function getADTGroupData(element, patientList, adtTotal, { totalType = null, isTooltip = false, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = {}) {
	let filtersArray = [];

	const groupByData = await _.groupBy(patientList, element.id);
	if (!_.isEmpty(groupByData)) {
		for await (const [key, value] of Object.entries(groupByData)) {
			if (key != "null") {
				const arrayLabelData = value[0];
				const admissionIds = _.map(value, "admissionId") || [];
				const transferIds = _.map(value, "id") || [];
				const total = value.length || 0;
				let originalTotal = total;
				if (totalType == TOTAL_TYPE.FILTER) {
					const tableData = element.tableData ? element.tableData : [];
					const findTableData = _.find(tableData, { _id: arrayLabelData[element.relation]["_id"] });
					originalTotal = findTableData?.originalTotal || 0;
				}
				const relationIdLet = element && element.relation && arrayLabelData[element.relation] ? arrayLabelData[element.relation]["_id"] : null;
				const relationLabelLet = element && element.relation && arrayLabelData[element.relation] ? arrayLabelData[element.relation]["label"] : null;
				if (relationIdLet && relationLabelLet) {
					const object = {
						id: relationIdLet,
						name: relationLabelLet,
						_id: relationIdLet,
						label: relationLabelLet,
						total,
						originalTotal,
						isTooltip,
						patientIds: admissionIds,
						transferIds,
						admissionIds: admissionIds,
						percentage: await itemPercentage(total, adtTotal, "number", PAGE_TYPE.ADMISSION),
						type: element.type,
						element: element,
					};
					filtersArray.push(object);
				}

			}
		}
		filtersArray = _.orderBy(filtersArray, "total", "desc");
	}

	// Attach level totals during data creation (matching admission page pattern)
	// Also attach card titles even for first filter (currentLevel = 1) if card titles are available
	const hasCardTitles = cardTitles && typeof cardTitles === 'object' && (
		cardTitles.level1 || cardTitles.level2 || cardTitles.level3 || cardTitles.level4 || cardTitles.level5
	);
	if (Array.isArray(filtersArray) && filtersArray.length > 0 &&
		((currentLevel >= 2 && intermediateTotals && Object.keys(intermediateTotals).length > 0) || hasCardTitles)) {
		filtersArray = attachADTLevelTotals(filtersArray, intermediateTotals || {}, currentLevel, cardTitles);
	}

	return filtersArray;
}

async function getADTGroupArrayData(element, patientList, adtTotal, { totalType = null, isTooltip = false, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = {}) {
	let filtersArray = [];
	let dxDataArr = [];
	if (patientList && patientList.length > 0) {
		// eslint-disable-next-line array-callback-return
		patientList.filter((ele) => {
			if (ele[element.id] && ele[element.id].length > 0) {
				let objectDev = ele[element.id];
				objectDev = objectDev.map((obj) => ({ ...obj, admissionId: ele.admissionId, patientId: ele.id }));
				dxDataArr = [...objectDev, ...dxDataArr];
			}
		});
		if (dxDataArr.length > 0) {
			const dxDataGroup = _.groupBy(dxDataArr, "_id");
			if (dxDataGroup) {
				for (const [key, value] of Object.entries(dxDataGroup)) {
					const valueArr = value[0];
					const admissionIds = _.map(value, "admissionId") || [];
					const transferIds = _.map(value, "patientId") || [];

					let originalTotal = value.length;
					if (totalType == TOTAL_TYPE.FILTER) {
						const tableData = element.tableData ? element.tableData : [];
						const findTableData = _.find(tableData, { _id: key });
						originalTotal = findTableData?.originalTotal || 0;
					}

					if (key && valueArr) {
						let object = {
							id: key,
							_id: key,
							name: valueArr.label,
							label: valueArr.label,
							total: value.length,
							type: element.type,
							originalTotal,
							isTooltip,
							percentage: itemPercentage(value.length, adtTotal, "number", PAGE_TYPE.ADMISSION),
							element: element,
							patientIds: transferIds,
							admissionIds: admissionIds,
							transferIds,
						};
						filtersArray.push(object);
					}
				}
			}
			filtersArray = _.orderBy(filtersArray, "total", "desc");
		}
	}

	// Attach level totals during data creation (matching admission page pattern)
	// Also attach card titles even for first filter (currentLevel = 1) if card titles are available
	const hasCardTitles = cardTitles && typeof cardTitles === 'object' && (
		cardTitles.level1 || cardTitles.level2 || cardTitles.level3 || cardTitles.level4 || cardTitles.level5
	);
	if (Array.isArray(filtersArray) && filtersArray.length > 0 &&
		((currentLevel >= 2 && intermediateTotals && Object.keys(intermediateTotals).length > 0) || hasCardTitles)) {
		filtersArray = attachADTLevelTotals(filtersArray, intermediateTotals || {}, currentLevel, cardTitles);
	}

	return filtersArray;
}

export async function adtCardFilterParam(adtData) {
	let transferTypes = [];
	let relations = [];
	let isReturnData = false;
	let isReHospitalization = false;
	let isNinetyDays = false;
	let isSixtyDays = false;
	let isNinetyDeceasedDays = false;
	let isNinetyOverallDays = false;
	adtData.map((ele) => {
		if (_.find(ele.children, { id: "wasReturned" })?.isSelected) {
			isReturnData = true;
		}
		if (ele.id === PAGE_TYPE.HOSPITAL) {
			if (_.find(ele.children, { id: "90Days" })?.isSelected) {
				isNinetyDays = true;
			}
			if (_.find(ele.children, { id: "reHospitalization" })?.isSelected) {
				isReHospitalization = true;
			}
			transferTypes = _.concat(transferTypes, ["plannedHospitalTransfer", "unplannedHospitalTransfer"]);
		}
		if (ele.id === PAGE_TYPE.COMMUNITY_TRANSFER) {
			if (_.find(ele.children, { id: "60Days" })?.isSelected) {
				isSixtyDays = true;
			}
			transferTypes = _.concat(transferTypes, ["AMA", "SNF", "safeDischarge"]);
		}
		if (ele.id === PAGE_TYPE.DECEASED) {
			if (_.find(ele.children, { id: "90DaysDeceased" })?.isSelected) {
				isNinetyDeceasedDays = true;
			}
			transferTypes = _.concat(transferTypes, ["deceased"]);
		}
		if (ele.id === PAGE_TYPE.OVERALL) {
			if (_.find(ele.children, { id: "90DaysOverall" })?.isSelected) {
				isNinetyOverallDays = true;
			}
			transferTypes = [];
		}
		if (ele.children && ele.children.length > 0) {
			const relationsData = _.map(_.filter(ele.children, { isSelected: true }), "relation").filter((item) => item);
			relations = _.concat(relations, relationsData);
		}
		relations = _.uniq(relations);
	});

	return {
		transferTypes,
		relations,
		isReturnData,
		isReHospitalization,
		isNinetyDays,
		isSixtyDays,
		isNinetyDeceasedDays,
		isNinetyOverallDays,
	};
}
export async function updateFacilityPercentageTotal(data, forComparison) {
	let facilityWiseTotal = _(data)
		.groupBy("facilityId")
		.sortBy((group) => data.indexOf(group[0]))
		.map((product) => {
			return {
				id: product[0]?.facilityId,
				total: product.length || 0,
			};
		})
		.value();
	forComparison
		? store.dispatch(setAdtFacilityPercentageComparison(facilityWiseTotal))
		: store.dispatch(setAdtFacilityPercentage(facilityWiseTotal));
}

export async function updateFilterListDataBoth(
	patientList,
	cardFilter,
	transferType,
	priorityData,
	defaultADTData,
	forComparison,
	defaultCardEdited
) {
	const { list, adtList, customTabs = [], diffDashboardPatients } = patientList;
	let adtTabTableData = adtList ?? [];
	let allPagesCustomTabs = patientList?.allPagesCustomTabs ?? {};
	let patientFilterData = list;
	let adtFilterData = adtList?.list ?? [];
	const {
		dbData,
		lockedTotal,
		lockedTotalBy
	} = forComparison ? store.getState().admissionComparison : store.getState().admission;
	const { dynamicCards: storeDynamicCards } = store.getState().admission;
	const dynamicCards = patientList?.dynamicCards ?? storeDynamicCards;
	const customCombineTabData = patientList?.customCombineTabData ?? [];
	const customDiffrentDashboardData = patientList?.customDiffrentDashboardData ?? {};

	const admissionCards = dynamicCards?.length > 0
		? dynamicCards.filter((ele) => ele.forType === ADT_TYPES.ADMISSIONS)
		: [];

	let censusAverage = dbData?.censusAverage;

	if (!forComparison) {
		censusAverage = await getDynamicPercentageBy(dbData);
	}

	let lockedTotalModified = lockedTotal;
	let mainNumPercentage = censusAverage;
	let isComparingAgainstAvgCensus = true;

	if (!forComparison) {
		store.dispatch(setAdtFacilityPercentage([]));
	} else {
		store.dispatch(setAdtFacilityPercentageComparison([]));
	}
	console.log(priorityData, 'priorityData chirag23');

	const transferTypeConsumesLevel = transferType && transferType !== ADMISSION_TYPES.ALL;

	const activeFiltersCount = priorityData ? priorityData.filter(e => e.type !== "census").length : 0;

	let totalFilterData = {
		originalData: patientFilterData,
		totalType: !forComparison ? (transferTypeConsumesLevel || activeFiltersCount > 0) ? TOTAL_TYPE.FILTER : TOTAL_TYPE.MAIN : TOTAL_TYPE.MAIN,
		totalForPercentage: censusAverage,
		defaultCardEdited: defaultCardEdited,
	};

	if (transferType === ADMISSION_TYPES.ADMISSION) {
		patientFilterData = _.filter(patientFilterData, {
			type: ADMISSION_TYPES.ADMISSION,
		});
	}
	if (transferType === ADMISSION_TYPES.READMISSION) {
		patientFilterData = _.filter(patientFilterData, {
			type: ADMISSION_TYPES.READMISSION,
		});
	}
	if (transferType) {
		mainNumPercentage = null;
		totalFilterData.totalForPercentage = patientFilterData.length;
		isComparingAgainstAvgCensus = false;
	}
	let objectCustom = Object();
	let newSavedFilters = [];
	let newADTData = [];

	batch(async () => {
		const newPayload = [];
		if (forComparison) {
			const currentFacilityPercentage = store.getState().admissionComparison.facilityPercentage;
			if (!_.isEqual(currentFacilityPercentage, newPayload)) {
				store.dispatch(setFacilityPercentageComparison(newPayload))
			}
		} else {
			const currentFacilityPercentage = store.getState().admission.facilityPercentage;
			if (!_.isEqual(currentFacilityPercentage, newPayload)) {
				store.dispatch(setFacilityPercentage(newPayload))
			}
		}

		if (!lockedTotalModified) {

			const newLockedTotalBy = null;
			if (forComparison) {
				const currentLockedTotalBy = store.getState().admissionComparison.lockedTotalBy;
				if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
					store.dispatch(setLockedTotalByComparison(newLockedTotalBy))
				}
			} else {
				const currentLockedTotalBy = store.getState().admission.lockedTotalBy;
				if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
					store.dispatch(setLockedTotalBy(newLockedTotalBy))
				}
			}

			!forComparison && store.dispatch(setIsCensusTotalLocked(false));
		}

		if (lockedTotalBy) {
			const newLockedTotalBy = null;
			const newLockTotal = null;
			if (
				lockedTotalBy === ADMISSION_TYPES.ALL ||
				lockedTotalBy === ADMISSION_TYPES.ADMISSION ||
				lockedTotalBy === ADMISSION_TYPES.READMISSION ||
				lockedTotalBy === "census"
			) {
				//if (lockedTotalModified && transferType !== lockedTotalBy && lockedTotalBy !== "census") {
				if (lockedTotalModified && !transferType && lockedTotalBy !== "census") {
					if (forComparison) {
						const currentLockedTotalBy = store.getState().admissionComparison.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalByComparison(newLockedTotalBy))
						}
					} else {
						const currentLockedTotalBy = store.getState().admission.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalBy(newLockedTotalBy))
						}
					}

					if (forComparison) {
						const currentLockedTotal = store.getState().admissionComparison.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotalComparison(newLockTotal))
						}
					} else {
						const currentLockedTotal = store.getState().admission.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotal(newLockTotal))
						}
					}

					lockedTotalModified = null;
				}
			} else {
				const lockedFilterRemoved = _.find(priorityData, (ele) => {
					let typeData =
						ele.filterType === ADMISSION_FILTER_TYPE.ADT ? ele?.type + "_" + ADMISSION_FILTER_TYPE.ADT : ele?.type;
					return typeData === lockedTotalBy ? ele : null;
				});
				//const lockedFilterRemoved = _.find(mainPriorityData, { type: lockedTotalBy });
				if (!lockedFilterRemoved) {
					if (forComparison) {
						const currentLockedTotalBy = store.getState().admissionComparison.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalByComparison(newLockedTotalBy))
						}
					} else {
						const currentLockedTotalBy = store.getState().admission.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalBy(newLockedTotalBy))
						}
					}

					if (forComparison) {
						const currentLockedTotal = store.getState().admissionComparison.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotalComparison(newLockTotal))
						}
					} else {
						const currentLockedTotal = store.getState().admission.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotal(newLockTotal))
						}
					}

					lockedTotalModified = null;
				}
			}
		}

	});

	if (lockedTotalModified) {
		totalFilterData.totalForPercentage = lockedTotalModified;
	}

	if (priorityData?.length > 0) {
		isComparingAgainstAvgCensus = false;
	}

	if (
		(priorityData?.length > 0 && (!lockedTotalBy || !lockedTotal)) ||
		(priorityData?.length > 0 &&
			lockedTotalBy !== "census" &&
			lockedTotalBy !== ADMISSION_TYPES.ALL &&
			lockedTotalBy !== ADMISSION_TYPES.ADMISSION &&
			lockedTotalBy !== ADMISSION_TYPES.READMISSION)
	) {
		totalFilterData.totalForPercentage = null;
	}

	let dynamicCardsObj = {};
	let customTabsObj = {};
	let adtOriginalData = adtFilterData || [];

	// Collect intermediate patient sets before each filter is applied (for tooltip only).
	// This does not change any existing calculations; it's read-only data for UI.
	const intermediateTotals = {};
	const adtIntermediateTotals = {};
	const cardTitles = {};
	const adtCardTitles = {};

	// If transferType is selected, store it as level1 before priorityData loop

	if (transferTypeConsumesLevel) {
		intermediateTotals.level1 = _.cloneDeep(patientFilterData);
		// Also store ADT data filtered by current admission IDs
		const currentAdmissionIds = _.map(patientFilterData, "id");
		const adtDataForLevel = _.filter(adtOriginalData, ({ admissionId }) =>
			_.every([_.includes(currentAdmissionIds, admissionId)])
		);
		adtIntermediateTotals.level1 = _.cloneDeep(adtDataForLevel);

		// Get transferType label from ADMISSION_CARDS_LABELS
		let transferTypeLabel = '';
		if (transferType === ADMISSION_TYPES.ADMISSION) {
			transferTypeLabel = ADMISSION_CARDS_LABELS.admission || "New Admissions";
		} else if (transferType === ADMISSION_TYPES.READMISSION) {
			transferTypeLabel = ADMISSION_CARDS_LABELS.readmission || "Re-Admissions";
		} else {
			transferTypeLabel = transferType;
		}
		cardTitles.level1 = `${transferTypeLabel} total`;
		adtCardTitles.level1 = `${transferTypeLabel} total`;
	}

	// Calculate final level for remaining cards (accounts for transferType and active priority filters)
	const finalLevel = activeFiltersCount + (transferTypeConsumesLevel ? 1 : 0);

	if (priorityData?.length > 0) {

		let filterAdmissionsIds = _.map(patientFilterData, "id");
		let filterADTAdmissionId = [];
		let updatedADTData = [];
		let isADTFilterApply = false;
		let i = 0;
		let j = 0;
		let admissionTotal = 0;
		// Track only ADMISSION filter count for intermediate totals
		let admissionFilterCount = 0;
		// Track ADT filter count for intermediate totals
		let adtFilterCount = 0;
		// Use a single variable to track the previous filter (regardless of type)
		let previousFilter = null;

		// Tooltip specific state
		let currentValidFilterIndex = 0;
		let previousValidAdmissionTitle = '';
		let previousValidADTTitle = '';

		// Use a combined counter for both ADMISSION and ADT filters (since they're interdependent)
		// This ensures consistent level indexing across both filter types
		// Adjust starting level based on whether transferType is selected
		// If transferType exists, priorityData filters start at level2, otherwise at level1
		const levelOffset = transferTypeConsumesLevel ? 1 : 0;
		let combinedFilterCount = 0;
		for await (const ele of priorityData) {
			j++;

			let totalCountData = mainNumPercentage && j === 1 ? mainNumPercentage : totalFilterData.totalForPercentage;
			//totalCountData = lockedTotalModified ? lockedTotalModified : totalCountData;
			const { type, transferIds, childId, selectedIds, filterType } = ele;

			if (priorityData?.length === j && lockedTotalModified && !lockedTotalBy) {
				if (filterType === ADMISSION_FILTER_TYPE.ADMISSION) {
					forComparison
						? store.dispatch(setLockedTotalByComparison(ele.type))
						: store.dispatch(setLockedTotalBy(ele.type));
				} else {
					forComparison
						? store.dispatch(setLockedTotalByComparison(ele.type + "_" + filterType))
						: store.dispatch(setLockedTotalBy(ele.type + "_" + filterType));
					forComparison ? store.dispatch(setLockedlockeByADTComparison(ele)) : store.dispatch(setLockedlockeByADT(ele));
				}
			}

			admissionFilterCount++;
			combinedFilterCount++;

			const isTotalLock = ((ele.type === "census" || ele.type === "total" || ele.type === ADMISSION_TYPES.ALL || ele.type?.toLowerCase().includes("total")) && ele.filterType === ADMISSION_FILTER_TYPE.ADMISSION);
			if (!isTotalLock) {
				currentValidFilterIndex++;
			}

			// Calculate actual level accounting for transferType offset ONLY for level computation
			const actualLevel = currentValidFilterIndex + levelOffset;

			if (filterType === ADMISSION_FILTER_TYPE.ADMISSION) {
				if (!isTotalLock) {
					if (currentValidFilterIndex > 1 && currentValidFilterIndex <= 6) {
						const storageLevel = (currentValidFilterIndex - 1) + levelOffset;
						if (storageLevel >= 1 && storageLevel <= 5) {
							// Store ADMISSION snapshot
							intermediateTotals[`level${storageLevel}`] = _.cloneDeep(patientFilterData);

							cardTitles[`level${storageLevel}`] = previousValidAdmissionTitle ? `${previousValidAdmissionTitle} total` : '';

							// Also store ADT snapshot (filtered by current admission IDs) since ADMISSION filter affects ADT data
							const currentAdmissionIds = _.map(patientFilterData, "id");
							const adtDataForLevel = _.filter(adtOriginalData, ({ admissionId }) =>
								_.every([_.includes(currentAdmissionIds, admissionId)])
							);
							adtIntermediateTotals[`level${storageLevel}`] = _.cloneDeep(adtDataForLevel);

							// Store ADT card title from previous filter
							adtCardTitles[`level${storageLevel}`] = previousValidADTTitle ? `${previousValidADTTitle} total` : '';
						}
					}

					const adtTitleFallback = ele?.subTitle || ele?.label || ele?.cardTitle || ele?.type || '';
					const admissionTitleFallback = ele?.cardTitle || ele?.subTitle || ele?.label || ele?.type || '';

					previousValidAdmissionTitle = admissionTitleFallback;
					previousValidADTTitle = adtTitleFallback;
				}

				previousFilter = ele;

				if (ele?.question?.isCustom) {
					const customTabsRes = customTabs.filter((x) => x.accessor === ele.type);
					if (customTabsRes.length > 0) {
						const isCombineTab =
							(ele?.question?.customTab || ele?.customTab)?.type === CUSTOM_TAB_TYPE.combineTab;
						// For combineTab: Always use mainNumPercentage (original data length before filters)
						// If mainNumPercentage is not available, use originalData.length as fallback (originalData is the unfiltered data)
						// This ensures percentage is always calculated based on original data length, not filtered data
						const originalDataLength = totalFilterData?.originalData?.length || patientFilterData.length;
						const totalForPercentage = isCombineTab
							? (mainNumPercentage || originalDataLength || totalFilterData.totalForPercentage)
							: (mainNumPercentage && j === 1 ? mainNumPercentage : totalFilterData.totalForPercentage);

						const isCheckNewFilters = true;
						customTabsObj = await getCustomTabsCards(patientFilterData, customTabsRes, { ...totalFilterData, totalType: TOTAL_TYPE.FILTER, originalData: patientFilterData, totalForPercentage, intermediateTotals, currentLevel: actualLevel, cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }, forComparison }, { dynamicCards, pageType: PAGE_TYPE.ADMISSION, diffDashboardPatients, forComparison, customCombineTabData, isCheckNewFilters, newSavedFilters: [...newSavedFilters, ele.type] });
					}
					objectCustom = { ...objectCustom, ...dynamicCardsObj, ...customTabsObj }

					patientFilterData = filterCustomPatientData(patientFilterData, cardFilter, ele);
				}

				if (isADTFilterApply) {
					patientFilterData = _.filter(patientFilterData, async ({ id }) =>
						_.every([_.includes(filterADTAdmissionId, id)])
					);
				}

				if (ele.type === ADMISSION_CARDS_TYPE.DOCTOR_DATA) {
					objectCustom.doctorData = await doctorData(patientFilterData, {
						...totalFilterData,
						totalForPercentage: totalCountData,
						intermediateTotals,
						currentLevel: actualLevel,
						cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					});
					objectCustom.doctorData = attachLevelTotals(
						objectCustom.doctorData,
						{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
						actualLevel,
						(p) => p.doctorId ?? p._id ?? p.id,
						{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
					);

					patientFilterData = _.filter(patientFilterData, ({ doctorId }) =>
						_.every([_.includes(cardFilter.doctorData, doctorId)])
					);
				}

				if (ele.type === ADMISSION_CARDS_TYPE.DAYS_DATA) {
					objectCustom.daysData = await daysData(patientFilterData, {
						...totalFilterData,
						totalForPercentage: totalCountData,
						intermediateTotals,
						currentLevel: actualLevel,
						cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					});
					objectCustom.daysData = maybeAttachTotals(
						objectCustom.daysData,
						{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
						actualLevel,
						(p) => p.day ?? p._id ?? p.id,
						{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
					);

					patientFilterData = _.filter(patientFilterData, ({ day }) => _.every([_.includes(cardFilter.daysData, day)]));
				}

				if (ele.type === ADMISSION_CARDS_TYPE.DX_DATA) {
					objectCustom.dxData = await dxData(patientFilterData, {
						...totalFilterData,
						totalForPercentage: totalCountData,
						intermediateTotals,
						currentLevel: actualLevel,
						cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					});
					objectCustom.dxData = maybeAttachTotals(
						objectCustom.dxData,
						{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
						actualLevel,
						(p) => p._id ?? p.id,
						{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
					);

					patientFilterData = _.filter(patientFilterData, ({ dxIds }) => {
						const matchedIds = _.intersection(cardFilter.dxData, dxIds);
						return matchedIds.length > 0 ? true : false;
					});
				}

				if (ele.type === ADMISSION_CARDS_TYPE.INSURANCE_DATA) {
					objectCustom.insuranceData = await insuranceData(patientFilterData, {
						...totalFilterData,
						totalForPercentage: totalCountData,
						intermediateTotals,
						currentLevel: actualLevel,
						cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					});
					objectCustom.insuranceData = maybeAttachTotals(
						objectCustom.insuranceData,
						{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
						actualLevel,
						(p) => p.insuranceId ?? p._id ?? p.id,
						{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
					);

					patientFilterData = _.filter(patientFilterData, ({ insuranceId }) =>
						_.every([_.includes(cardFilter.insuranceData, insuranceId)])
					);
				}

				if (ele.type === ADMISSION_CARDS_TYPE.FLOORS_DATA) {
					objectCustom.floorsData = await floorsData(patientFilterData, {
						...totalFilterData,
						totalForPercentage: totalCountData,
						intermediateTotals,
						currentLevel: actualLevel,
						cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					});
					objectCustom.floorsData = attachLevelTotals(
						objectCustom.floorsData,
						{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
						actualLevel,
						(p) => p.floorId ?? p._id ?? p.id,
						{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
					);

					patientFilterData = _.filter(patientFilterData, ({ floorId }) =>
						_.every([_.includes(cardFilter.floorsData, floorId)])
					);
				}

				if (ele.type === ADMISSION_CARDS_TYPE.HOSPITAL_DATA) {
					objectCustom.hospitalData = await hospitalListData(patientFilterData, {
						...totalFilterData,
						totalForPercentage: totalCountData,
						intermediateTotals,
						currentLevel: actualLevel,
					});
					objectCustom.hospitalData = maybeAttachTotals(
						objectCustom.hospitalData,
						{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
						actualLevel,
						(p) => p.hospitalId ?? p._id ?? p.id,
						{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
					);

					patientFilterData = _.filter(patientFilterData, ({ hospitalId }) =>
						_.every([_.includes(cardFilter.hospitalData, hospitalId)])
					);
				}
				admissionTotal = patientFilterData.length;

				store.dispatch(
					forComparison
						? setFilterTotalComparison(lockedTotalModified ? lockedTotalModified : patientFilterData.length)
						: setFilterTotal(lockedTotalModified ? lockedTotalModified : patientFilterData.length)
				);
				store.dispatch(
					forComparison
						? setFilterTotalWithoutLockComparison(patientFilterData.length)
						: setFilterTotalWithoutLock(patientFilterData.length)
				);
				filterAdmissionsIds = _.map(patientFilterData, "id");
				newSavedFilters.push(ele);
				if (j === priorityData?.length) {
					updateFacilityPercentageTotal(patientFilterData, forComparison);
				}
			} else {
				i++;
				isADTFilterApply = true;
				adtFilterCount++;

				// Calculate actual level accounting for transferType offset ONLY for level computation
				const actualLevel = currentValidFilterIndex + levelOffset;

				if (!isTotalLock) {
					if (currentValidFilterIndex > 1 && currentValidFilterIndex <= 6) {
						const storageLevel = (currentValidFilterIndex - 1) + levelOffset;
						if (storageLevel >= 1 && storageLevel <= 5) {
							// Store ADT snapshot BEFORE filtering by admission IDs
							if (adtFilterData && adtFilterData.length > 0) {
								adtIntermediateTotals[`level${storageLevel}`] = _.cloneDeep(adtFilterData);
							}

							adtCardTitles[`level${storageLevel}`] = previousValidADTTitle ? `${previousValidADTTitle} total` : '';

							// Also store ADMISSION snapshot since ADT filter affects admission data
							if (patientFilterData && patientFilterData.length > 0) {
								intermediateTotals[`level${storageLevel}`] = _.cloneDeep(patientFilterData);
							}

							cardTitles[`level${storageLevel}`] = previousValidAdmissionTitle ? `${previousValidAdmissionTitle} total` : '';
						}
					}

					const adtTitleFallback = ele?.subTitle || ele?.label || ele?.cardTitle || ele?.type || '';
					const admissionTitleFallback = ele?.cardTitle || ele?.subTitle || ele?.label || ele?.type || '';

					previousValidADTTitle = adtTitleFallback;
					previousValidAdmissionTitle = admissionTitleFallback;
				}

				previousFilter = ele;

				// Now apply the admission ID filter
				adtFilterData = _.filter(adtFilterData, ({ admissionId }) =>
					_.every([_.includes(filterAdmissionsIds, admissionId)])
				);

				// Calculate totalForPercentage - use the ADT data length BEFORE this filter for correct totals
				let totalForPercentage;
				if (combinedFilterCount === 1) {
					// First filter: use patientFilterData length (initial state)
					totalForPercentage = patientFilterData?.length;
				} else if (combinedFilterCount > 1 && adtIntermediateTotals[`level${combinedFilterCount - 1}`]) {
					// Use the snapshot data length (before this filter was applied)
					totalForPercentage = adtIntermediateTotals[`level${combinedFilterCount - 1}`].length;
				} else {
					// Fallback to current filtered data
					totalForPercentage = adtFilterData.length;
				}

				admissionTotal = totalForPercentage;
				let totalCountADTData =
					!transferType && j === 1 ? censusAverage : lockedTotalModified ? lockedTotalModified : totalForPercentage;
				if (!transferType) {
					isComparingAgainstAvgCensus = true;
				}
				const adtCardTitlesToPass = { level1: adtCardTitles.level1, level2: adtCardTitles.level2, level3: adtCardTitles.level3, level4: adtCardTitles.level4, level5: adtCardTitles.level5 };
				const isAdtCustomCard = isAdtCustomTabRow(ele, type);
				const isAdtCustomCombine =
					isAdtCustomCard &&
					(ele?.question?.customTab || ele?.customTab)?.type === CUSTOM_TAB_TYPE.combineTab;

				let tableDataNew = await getTableDataFilter(ele, adtFilterData, adtTabTableData,
					totalCountADTData, {
					totalType: TOTAL_TYPE.FILTER,
					isTooltip: true, // Always true for ADT filter data to enable tooltip with level totals
					forComparison,
					intermediateTotals: adtIntermediateTotals,
					currentLevel: actualLevel,
					cardTitles: adtCardTitlesToPass,
					admissionPatientList: patientFilterData,
					customCombineTabData,
					customDiffrentDashboardData,
					diffDashboardPatients,
					dynamicCards,
					mainNumPercentage,
					allPagesCustomTabs
				});

				updatedADTData.push(attachResolvedCustomTabToAdtRow(ele, tableDataNew, allPagesCustomTabs));

				let transferIdsData = transferIds;
				// First ADT filter historically used row-id remapping; combine tabs must also remap when they are not the first ADT filter (selectedIds vs table row ids).
				const shouldRemapSelectedIdsToTransferIds =
					(i === 1 || isAdtCustomCard) &&
					(type === ADT_TABLE_TYPE.ANALYSIS_CHART || type === ADT_TABLE_TYPE.CUSTOM);
				if (shouldRemapSelectedIdsToTransferIds) {
					const selectedIdData = ele?.selectedIds || [];
					if (selectedIdData.length > 0) {
						let transferIdsDataLatest2 = [];
						tableDataNew.forEach((eleTable) => {
							const selectedById =
								_.includes(selectedIdData, eleTable?._id) ||
								_.includes(selectedIdData, eleTable?.id);
							if (selectedById) {
								transferIdsDataLatest2 = [
									...transferIdsDataLatest2,
									...(Array.isArray(eleTable?.ids) ? eleTable.ids : []),
									...(Array.isArray(eleTable?.patientIds) ? eleTable.patientIds : []),
								];
							}
						});
						transferIdsData = _.uniq(transferIdsDataLatest2);
						// Combine ADT: totalByPage.patientIds may be admission ids or ADT transfer row ids; transferIds aligns with that.
						// selectedIds may be composite keys that don't match table row ids.
						// If remapping produced no ids, keep the original ids instead of collapsing to empty.
						if (
							isAdtCustomCombine &&
							(!transferIdsData || transferIdsData.length === 0)
						) {
							const fallbackFromEle = Array.isArray(ele?.transferIds) ? ele.transferIds : [];
							const accessorForCombine = ele?.accessor || ele?.question?.accessor;
							const firstCombineRow = Array.isArray(tableDataNew) ? tableDataNew[0] : null;
							let fromTotalByPage = [];
							if (accessorForCombine && firstCombineRow?.totalByPage) {
								const accPrefix = `${accessorForCombine}__`;
								const collected = [];
								selectedIdData.forEach((sid) => {
									if (typeof sid === "string" && sid.startsWith(accPrefix)) {
										const uniqueKeyFromComposite = sid.slice(accPrefix.length);
										const p = firstCombineRow.totalByPage[uniqueKeyFromComposite]?.patientIds;
										if (Array.isArray(p)) collected.push(...p);
									}
								});
								fromTotalByPage = collected;
							}
							if ((!fromTotalByPage || fromTotalByPage.length === 0) && ele?.question?.uniqueKey && firstCombineRow?.totalByPage) {
								fromTotalByPage = firstCombineRow.totalByPage[ele.question.uniqueKey]?.patientIds ?? [];
							}
							transferIdsData = _.uniq([
								...fallbackFromEle,
								...(Array.isArray(fromTotalByPage) ? fromTotalByPage : []),
							]);
						}
					}
				}
				adtFilterData = _.filter(adtFilterData, (item) => {
					let filterArr = [];
					const idD = item[childId];
					const { id } = item;
					const admissionId = item?.admissionId;
					if (type === ADT_TABLE_TYPE.GROUP) {
						filterArr.push(_.includes(selectedIds, idD));
					} else if (type === ADT_TABLE_TYPE.GROUP_ARRAY) {
						filterArr.push(_.includes(transferIdsData, id));
					} else if (type === ADT_TABLE_TYPE.DAY_CHART) {
						filterArr.push(_.includes(transferIdsData, idD));
					} else if (type === ADT_TABLE_TYPE.CUSTOM) {
						// Custom/combine totalByPage.patientIds may be admission ids or ADT transfer row ids; match either.
						if (isAdtCustomCard) {
							filterArr.push(
								_.includes(transferIdsData, admissionId) || _.includes(transferIdsData, id)
							);
						} else {
							filterArr.push(_.includes(transferIdsData, id));
						}
					} else if (type === ADT_TABLE_TYPE.ANALYSIS_CHART) {
						filterArr.push(_.includes(transferIdsData, id));
					} else if (type === ADT_TABLE_TYPE.CHART || type === ADT_TABLE_TYPE.ALL || ADT_TABLE_TYPE.TOTAL) {
						filterArr.push(_.includes(transferIdsData, id));
					}
					return _.every(filterArr);
				});

				if (ele.parentId === PAGE_TYPE.HOSPITAL) {
					adtFilterData = _.filter(adtFilterData, ({ transferType }) =>
						_.every([_.includes(["plannedHospitalTransfer", "unplannedHospitalTransfer"], transferType)])
					);
				}

				if (ele.parentId === PAGE_TYPE.COMMUNITY_TRANSFER) {
					adtFilterData = _.filter(adtFilterData, ({ transferType }) =>
						_.every([_.includes(["AMA", "SNF", "safeDischarge"], transferType)])
					);
				}

				if (ele.parentId === PAGE_TYPE.DECEASED) {
					adtFilterData = _.filter(adtFilterData, ({ transferType }) =>
						_.every([_.includes(["deceased"], transferType)])
					);
				}
				filterADTAdmissionId = _.map(adtFilterData, "admissionId");
				patientFilterData = _.filter(patientFilterData, ({ id }) => {
					return _.every([_.includes(filterADTAdmissionId, id)]);
				});
				if (j === priorityData?.length) {
					updateFacilityPercentageTotal(adtFilterData, forComparison);
				}
				if (i == 1) {
					store.dispatch(
						forComparison
							? setFilterTotalComparison(lockedTotalModified ? lockedTotalModified : adtFilterData.length)
							: setFilterTotal(lockedTotalModified ? lockedTotalModified : adtFilterData.length)
					);
					store.dispatch(
						forComparison
							? setFilterTotalWithoutLockComparison(adtFilterData.length)
							: setFilterTotalWithoutLock(adtFilterData.length)
					);
				} else {
					if (forComparison) {
						if (lockedTotalModified) {
							store.dispatch(setFilterTotalComparison(lockedTotalModified));
						} else {
							if (mainNumPercentage) {
								store.dispatch(setFilterTotalComparison(mainNumPercentage));
							} else {
								store.dispatch(setFilterTotalComparison(patientFilterData.length));
							}
						}
					} else {
						if (lockedTotalModified) {
							store.dispatch(setFilterTotal(lockedTotalModified));
						} else {
							if (mainNumPercentage && i === 1) {
								store.dispatch(setFilterTotal(mainNumPercentage));
							} else {
								store.dispatch(setFilterTotal(patientFilterData.length));
							}
						}
					}

					store.dispatch(
						forComparison
							? setFilterTotalWithoutLockComparison(mainNumPercentage ? mainNumPercentage : patientFilterData.length)
							: setFilterTotalWithoutLock(mainNumPercentage ? mainNumPercentage : patientFilterData.length)
					);
				}
			}
		}
		const totalPercentageCount = lockedTotalModified ? lockedTotalModified : patientFilterData.length; //transferType ? patientFilterData?.length : censusAverage

		const selectedDoctorFilter = _.find(newSavedFilters, {
			type: ADMISSION_CARDS_TYPE.DOCTOR_DATA,
			filterType: ADMISSION_FILTER_TYPE.ADMISSION,
		});

		const selectedAverageStayDaysFilter = _.find(newSavedFilters, {
			type: ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA,
			filterType: ADMISSION_FILTER_TYPE.ADMISSION,
		});
		if (_.isEmpty(selectedAverageStayDaysFilter)) {
			objectCustom.averageStayDaysData = await averageLengthOfStayData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
			});
		}
		if (_.isEmpty(selectedDoctorFilter)) {
			objectCustom.doctorData = await doctorData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.doctorData = attachLevelTotals(
				objectCustom.doctorData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.doctorId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}

		const selectedDaysFilter = _.find(newSavedFilters, {
			type: ADMISSION_CARDS_TYPE.DAYS_DATA,
			filterType: ADMISSION_FILTER_TYPE.ADMISSION,
		});
		if (_.isEmpty(selectedDaysFilter)) {
			objectCustom.daysData = await daysData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.daysData = maybeAttachTotals(
				objectCustom.daysData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.day ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}

		const selectedDxFilter = _.find(newSavedFilters, {
			type: ADMISSION_CARDS_TYPE.DX_DATA,
			filterType: ADMISSION_FILTER_TYPE.ADMISSION,
		});
		if (_.isEmpty(selectedDxFilter)) {
			objectCustom.dxData = await dxData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.dxData = maybeAttachTotals(
				objectCustom.dxData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}

		const selectedInsuranceFilter = _.find(newSavedFilters, {
			type: ADMISSION_CARDS_TYPE.INSURANCE_DATA,
			filterType: ADMISSION_FILTER_TYPE.ADMISSION,
		});
		if (_.isEmpty(selectedInsuranceFilter)) {
			objectCustom.insuranceData = await insuranceData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.insuranceData = maybeAttachTotals(
				objectCustom.insuranceData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.insuranceId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}

		const selectedFloorFilter = _.find(newSavedFilters, {
			type: ADMISSION_CARDS_TYPE.FLOORS_DATA,
			filterType: ADMISSION_FILTER_TYPE.ADMISSION,
		});
		if (_.isEmpty(selectedFloorFilter)) {
			objectCustom.floorsData = await floorsData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.floorsData = attachLevelTotals(
				objectCustom.floorsData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.floorId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}

		const selectedHospitalFilter = _.find(newSavedFilters, {
			type: ADMISSION_CARDS_TYPE.HOSPITAL_DATA,
			filterType: ADMISSION_FILTER_TYPE.ADMISSION,
		});
		if (_.isEmpty(selectedHospitalFilter)) {
			objectCustom.hospitalData = await hospitalListData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.hospitalData = maybeAttachTotals(
				objectCustom.hospitalData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.hospitalId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}
		objectCustom.admissionTotal = admissionTotal;

		adtFilterData = _.filter(adtFilterData, ({ admissionId }) =>
			_.every([_.includes(filterAdmissionsIds, admissionId)])
		);

		if (admissionCards.length > 0) {
			for (const item of admissionCards) {
				let objectCustomRes = {};
				const selectedCustomFilter = _.find(newSavedFilters, {
					type: item?.accessor,
					filterType: ADMISSION_FILTER_TYPE.ADMISSION,
				});

				if (_.isEmpty(selectedCustomFilter)) {
					await processDynamicCard(item, patientFilterData, objectCustomRes, {
						...totalFilterData,
						totalType: TOTAL_TYPE.FILTER,
						totalForPercentage: totalPercentageCount,
						intermediateTotals,
						currentLevel: finalLevel,
						cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					});
					if (!_.isEmpty(objectCustomRes)) {
						objectCustom[item?.accessor] = objectCustomRes?.[item?.accessor];
					}
				}
			}
		}

		if (customTabs.length > 0) {
			let customTabsObjRes = {};
			const isCheckNewFilters = true;
			// For combineTab: Always use mainNumPercentage (original data length before filters) to keep percentage consistent
			// Check if any of the custom tabs are combine tabs
			const hasCombineTab = customTabs.some(tab => tab?.type === CUSTOM_TAB_TYPE.combineTab);
			const originalDataLength = totalFilterData?.originalData?.length || patientFilterData.length;
			// For combine tabs, use mainNumPercentage if available, otherwise use originalDataLength
			// For other custom tabs, use totalPercentageCount (filtered data length)
			const totalForPercentageForCombineTabs = hasCombineTab
				? (mainNumPercentage || originalDataLength || totalFilterData.totalForPercentage)
				: totalPercentageCount;

			customTabsObjRes = await getCustomTabsCards(
				patientFilterData,
				customTabs,
				{ ...totalFilterData, totalType: TOTAL_TYPE.FILTER, totalForPercentage: totalForPercentageForCombineTabs, intermediateTotals, currentLevel: admissionFilterCount || 0, cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }, forComparison },
				{ dynamicCards, newSavedFilters, isCheckNewFilters, objectCustom, pageType: PAGE_TYPE.ADMISSION, diffDashboardPatients, forComparison, customCombineTabData }
			);
			objectCustom = { ...objectCustom, ...customTabsObjRes };
		}

		for await (const ele of defaultADTData) {
			const selectedFilter = _.find(updatedADTData, { childId: ele.childId, cardId: ele.cardId });
			if (selectedFilter) {
				newADTData.push(selectedFilter);
			} else {
				// For default ADT data, also pass level tracking parameters so level totals can be attached
				let tableDataNew = await getTableDataFilter(
					ele,
					adtFilterData,
					adtTabTableData,
					lockedTotalModified ? lockedTotalModified : patientFilterData.length, //patientFilterData.length,
					{
						totalType: TOTAL_TYPE.FILTER,
						isTooltip: true,
						totalForPercentage: totalPercentageCount,
						originalData: adtOriginalData,
						intermediateTotals: adtIntermediateTotals,
						currentLevel: finalLevel,
						cardTitles: { level1: adtCardTitles.level1, level2: adtCardTitles.level2, level3: adtCardTitles.level3, level4: adtCardTitles.level4, level5: adtCardTitles.level5 },
						admissionPatientList: patientFilterData,
						customCombineTabData,
						customDiffrentDashboardData,
						diffDashboardPatients,
						dynamicCards,
						mainNumPercentage,
						forComparison,
						allPagesCustomTabs
					}
				);
				newADTData.push(attachResolvedCustomTabToAdtRow(ele, tableDataNew, allPagesCustomTabs));
			}
		}

		if (!lockedTotalModified) {
			let lastPrioritySelected = _.last(priorityData);
			let patientLockedData = [];
			if (lastPrioritySelected && lastPrioritySelected.filterType === ADMISSION_FILTER_TYPE.ADMISSION) {
				patientLockedData = patientFilterData;
			} else if (lastPrioritySelected && lastPrioritySelected.filterType === ADMISSION_FILTER_TYPE.ADT) {
				patientLockedData = adtFilterData;
			}
			// ! problematic
			forComparison
				? store.dispatch(setLockedByFacilityComparison(patientFilterData))
				: store.dispatch(setLockedByFacility(patientFilterData));
			// store.dispatch(setLockedByFacility(patientFilterData));
		}
	} else {
		let totalCount;
		batch(async () => {
			if (lockedTotalModified) {
				totalCount = lockedTotalModified;
			} else if (mainNumPercentage) {
				totalCount = mainNumPercentage;
			} else if (transferType) {
				totalCount = patientFilterData?.length; // Optional chaining for safety
			} else {
				totalCount = censusAverage;
			}

			store.dispatch(forComparison ? setFilterTotalComparison(totalCount) : setFilterTotal(totalCount));

			if (!transferType && lockedTotalModified) {
				var isCensusTotalLocked = true;
				if (forComparison) {
					const currentIsCensusTotalLocked = store.getState().admissionComparison.isCensusTotalLocked;
					if (!_.isEqual(currentIsCensusTotalLocked, isCensusTotalLocked)) {
						store.dispatch(setIsCensusTotalLockedComparison(isCensusTotalLocked));
					}
				} else {
					const currentIsCensusTotalLocked = store.getState().admission.isCensusTotalLocked;
					if (!_.isEqual(currentIsCensusTotalLocked, isCensusTotalLocked)) {
						store.dispatch(setIsCensusTotalLocked(isCensusTotalLocked));
					}
				};
			}
			if (lockedTotalModified && !lockedTotalBy) {
				if (transferType) {
					forComparison
						? store.dispatch(setLockedTotalByComparison(transferType))
						: store.dispatch(setLockedTotalBy(transferType));
				} else {
					forComparison
						? store.dispatch(setLockedTotalByComparison("census"))
						: store.dispatch(setLockedTotalBy("census"));
				}
			}
			if (!lockedTotalModified) {
				// ! problematic
				forComparison
					? store.dispatch(setLockedByFacilityComparison(patientFilterData))
					: store.dispatch(setLockedByFacility(patientFilterData));
			}
		});
		[
			objectCustom.doctorData,
			objectCustom.daysData,
			objectCustom.dxData,
			objectCustom.insuranceData,
			objectCustom.floorsData,
			objectCustom.hospitalData,
			objectCustom.admissionTotal,
			objectCustom.averageStayDaysData,
		] = await Promise.all([
			doctorData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			daysData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			dxData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			insuranceData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			floorsData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			hospitalListData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			patientFilterData?.length,
			averageLengthOfStayData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 })
		]);

		let filterADTAdmissionId = _.map(patientFilterData, "id");

		adtFilterData = _.filter(adtFilterData, ({ admissionId }) =>
			_.every([_.includes(filterADTAdmissionId, admissionId)])
		);

		if (admissionCards.length > 0) {
			dynamicCardsObj = await dynamicCardFilter(patientFilterData, admissionCards, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 });
		}

		if (customTabs.length > 0) {
			customTabsObj = await getCustomTabsCards(patientFilterData, customTabs, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0, cardTitles: {}, forComparison }, { dynamicCards, pageType: PAGE_TYPE.ADMISSION, diffDashboardPatients, forComparison, customCombineTabData });
		}

		objectCustom = { ...objectCustom, ...dynamicCardsObj, ...customTabsObj }
		for await (const ele of defaultADTData) {
			let tableDataNew = await getTableDataFilter(ele, adtFilterData, adtTabTableData, totalCount, {
				totalType: TOTAL_TYPE.MAIN,
				isTooltip: transferType ? true : false,
				originalData: adtFilterData,
				admissionPatientList: patientFilterData,
				customCombineTabData,
				customDiffrentDashboardData,
				diffDashboardPatients,
				dynamicCards,
				mainNumPercentage,
				forComparison,
				allPagesCustomTabs
			});
			newADTData.push(attachResolvedCustomTabToAdtRow(ele, tableDataNew, allPagesCustomTabs));
		}
	}
	objectCustom.isComparingAgainstAvgCensus = isComparingAgainstAvgCensus;
	objectCustom.transferType = transferType;

	// ADT custom/combine tabs: tableData lives on each row; mirror onto filterListData object (same as main customTabs merge).
	for (const row of newADTData || []) {
		if (
			row?.type === ADT_TABLE_TYPE.CUSTOM &&
			(row?.customTab?.type === CUSTOM_TAB_TYPE.combineTab ||
				row?.customTab?.type === CUSTOM_TAB_TYPE.customTab) &&
			row?.accessor &&
			row.tableData != null
		) {
			objectCustom[row.accessor] = Array.isArray(row.tableData) ? row.tableData : [];
		}
	}

	return { patientList: objectCustom, adtList: newADTData };
}

async function getTableDataFilter(
	element,
	patientList,
	defaultPatientData,
	totalForPercentage,
	typeData,
	forComparison
) {
	let filtersArray = [];
	const type = element.type;
	// Extract level tracking parameters from typeData if they exist
	const intermediateTotals = typeData?.intermediateTotals || {};
	const currentLevel = typeData?.currentLevel || 0;
	const cardTitles = typeData?.cardTitles || {};
	const allPagesMap = normalizeAllPagesCustomTabsMap(typeData?.allPagesCustomTabs);
	// Extract forComparison from typeData if it's there (for backward compatibility)
	const forComparisonValue = typeData?.forComparison !== undefined ? typeData.forComparison : forComparison;

	if (element.parentId === PAGE_TYPE.HOSPITAL) {
		patientList = _.filter(patientList, ({ transferType }) =>
			_.every([_.includes(["plannedHospitalTransfer", "unplannedHospitalTransfer"], transferType)])
		);
	}
	if (element.parentId === PAGE_TYPE.COMMUNITY_TRANSFER) {
		patientList = await _.filter(patientList, ({ transferType }) =>
			_.every([_.includes(["AMA", "SNF", "safeDischarge"], transferType)])
		);
	}
	if (element.parentId === PAGE_TYPE.DECEASED) {
		patientList = await _.filter(patientList, ({ transferType }) => _.every([_.includes(["deceased"], transferType)]));
	}
	if (type === ADT_TABLE_TYPE.TOTAL) {
		filtersArray = await getADTTotalData(element, patientList, totalForPercentage, "transferType", {
			...typeData,
			intermediateTotals,
			currentLevel,
			cardTitles
		});
	}
	if (type === ADT_TABLE_TYPE.ALL) {
		filtersArray = await getADTTotalData(element, patientList, totalForPercentage, ADT_TABLE_TYPE.ALL, {
			...typeData,
			intermediateTotals,
			currentLevel,
			cardTitles
		});
	}
	if (type === ADT_TABLE_TYPE.ANALYSIS_CHART) {
		filtersArray = await getADTAnalysisChartData(
			element,
			defaultPatientData,
			patientList,
			totalForPercentage,
			{
				...typeData,
				intermediateTotals,
				currentLevel,
				cardTitles
			}
		);
	}

	if (type === ADT_TABLE_TYPE.DAY_CHART) {
		filtersArray = await getADTChartDaysData(element, patientList, totalForPercentage, {
			...typeData,
			intermediateTotals,
			currentLevel,
			cardTitles
		});
	}

	if (type === ADT_TABLE_TYPE.CHART) {
		filtersArray = await getADTChartData(element, patientList, totalForPercentage, {
			...typeData,
			intermediateTotals,
			currentLevel,
			cardTitles
		});
	}

	if (type === ADT_TABLE_TYPE.GROUP) {
		filtersArray = await getADTGroupData(element, patientList, totalForPercentage, {
			...typeData,
			intermediateTotals,
			currentLevel,
			cardTitles
		});
	}

	if (type === ADT_TABLE_TYPE.GROUP_ARRAY) {
		filtersArray = await getADTGroupArrayData(element, patientList, totalForPercentage, {
			...typeData,
			intermediateTotals,
			currentLevel,
			cardTitles
		});
	}

	if (type === ADT_TABLE_TYPE.CUSTOM) {
		const resolvedFromPages = resolveAdtCustomTabFromAllPages(element, allPagesMap);
		const effectiveTab = element?.customTab?.type ? element.customTab : resolvedFromPages || element?.customTab;
		if (effectiveTab?.type === CUSTOM_TAB_TYPE.combineTab || effectiveTab?.type === CUSTOM_TAB_TYPE.customTab) {
			const admissionList = patientList ?? [];
			const originalDataLength = typeData?.originalData?.length ?? admissionList.length;
			const totalForPctCombine =
				typeData?.mainNumPercentage != null
					? typeData.mainNumPercentage
					: originalDataLength || totalForPercentage;
			// Match Hospital ADT section: custom/combine filters use dashboard keys (hospital, admission, …); pageType is the ADT parent (e.g. hospital), not always admission.
			const combinePageType = element?.parentId || PAGE_TYPE.ADMISSION;
			const adtTabPayload = defaultPatientData && typeof defaultPatientData === "object" ? defaultPatientData : {};
			const diffDashboardPatientsRes = resolveAdtDiffDashboardPatients(typeData, admissionList);
			const customTabsObj = await getCustomTabsCards(
				admissionList,
				[effectiveTab],
				{
					...typeData,
					totalType: typeData?.totalType || TOTAL_TYPE.FILTER,
					totalForPercentage: totalForPctCombine,
					originalData: admissionList,
					intermediateTotals,
					currentLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					forComparison: forComparisonValue,
				},
				{
					dynamicCards: typeData?.dynamicCards,
					newSavedFilters: [],
					isCheckNewFilters: false,
					objectCustom: {},
					pageType: combinePageType,
					diffDashboardPatients: diffDashboardPatientsRes,
					forComparison: forComparisonValue,
					customCombineTabData: typeData?.customCombineTabData ?? [],
					ninetyDaysData: typeData?.ninetyDaysData ?? adtTabPayload?.ninetyDaysData,
					sixtyDaysData: typeData?.sixtyDaysData ?? adtTabPayload?.sixtyDaysData,
				}
			);
			filtersArray = customTabsObj?.[element?.accessor] ?? [];
			filtersArray = enrichAdtCustomCombineTableRowsWithAdmissionIds(
				filtersArray,
				patientList,
				typeData?.admissionPatientList ?? []
			);
		} else {
			let objectCustomRes = {};
			// Tab definition last: keep ADT row ids (childId, cardId, parentId, accessor) from element
			const elForDynamic = effectiveTab ? { ...effectiveTab, ...element } : element;

			await processDynamicCard(elForDynamic, patientList, objectCustomRes, {
				totalForPercentage: totalForPercentage,
				totalType: typeData?.totalType || TOTAL_TYPE.FILTER,
				isADT: true,
				originalData: typeData?.originalData || [],
				intermediateTotals,
				currentLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			});
			filtersArray = objectCustomRes?.[element?.accessor] ?? [];
			filtersArray = enrichAdtCustomCombineTableRowsWithAdmissionIds(
				filtersArray,
				patientList,
				typeData?.admissionPatientList ?? []
			);
		}
	}

	return filtersArray;
}

export async function getADTDataDefault(res, adtData, forComparison = false) {
	let transferData = [];
	for await (const item of adtData) {
		const childData = await _.filter(item.children, { isSelected: true });
		for await (const ele of childData) {
			// eslint-disable-next-line no-new-object
			let tableData = await getDefaultTableData(ele, res, forComparison);
			if (
				tableData &&
				tableData.length > 0 &&
				(ele.type === ADT_TABLE_TYPE.GROUP || ele.type === ADT_TABLE_TYPE.GROUP_ARRAY)
			) {
				tableData = _.orderBy(tableData, "total", "desc");
			}
			let newItem = new Object();
			newItem.title = item.label;
			newItem.label = item.label;
			newItem.cardId = item.id;
			newItem.parentId = item.id;
			newItem.relation = ele.relation;
			newItem.helperText = ele?.helperText || "";
			newItem.childId = ele.id;
			newItem.id = ele.id;
			newItem.childId = ele.id;
			newItem.subTitle = ele.label;
			newItem.type = ele.type;
			newItem.tableData = tableData;
			newItem.chartsLabel = ele?.chartsLabel || [];
			newItem.arrayName = ele?.arrayName || [];
			newItem.validationBase = ele?.validationBase;
			newItem.customQuestionInputType = ele?.customQuestionInputType;
			newItem.customQuestionOptions = ele?.customQuestionOptions;
			newItem.validationOptions = ele?.validationOptions;
			newItem.dateAnalysisStartQuestion = ele?.dateAnalysisStartQuestion;
			newItem.dateAnalysisEndQuestion = ele?.dateAnalysisEndQuestion;
			newItem.isDefaultCard = ele?.isDefaultCard;
			newItem.existingAccessor = ele?.existingAccessor;
			newItem.accessor = ele?.accessor;
			newItem.dateAnalysisStartQuestion = ele?.dateAnalysisStartQuestion;
			newItem.dateAnalysisEndQuestion = ele?.dateAnalysisEndQuestion;
			newItem.isDefaultCard = ele?.isDefaultCard;
			newItem.existingAccessor = ele?.existingAccessor;
			transferData.push(newItem);
		}
	}
	return transferData;
}

export async function getDefaultTableData(element, adtTabTableData, forComparison) {
	let filtersArray = [];
	let patientList = [];
	let arrayData = adtTabTableData.list || [];
	const type = element.type;
	const { adtTotal } = forComparison ? store.getState().admissionComparison : store.getState().admission;
	let totalForPercentage = adtTotal;
	if (element.parentId === PAGE_TYPE.HOSPITAL) {
		patientList = arrayData
			.map((item) =>
				_.includes(["plannedHospitalTransfer", "unplannedHospitalTransfer"], item.transferType) ? item : null
			)
			.filter((item) => item);
	}
	if (element.parentId === PAGE_TYPE.COMMUNITY_TRANSFER) {
		patientList = arrayData
			.map((item) => (_.includes(["AMA", "SNF", "safeDischarge"], item.transferType) ? item : null))
			.filter((item) => item);
	}
	if (element.parentId === PAGE_TYPE.DECEASED) {
		patientList = arrayData
			.map((item) => (_.includes(["deceased"], item.transferType) ? item : null))
			.filter((item) => item);
	}
	if (element.parentId === PAGE_TYPE.OVERALL) {
		patientList = arrayData;
	}

	if (type === ADT_TABLE_TYPE.TOTAL) {
		filtersArray = getADTTotalData(element, patientList, totalForPercentage, "transferType", TOTAL_TYPE.MAIN);
	}
	if (type === ADT_TABLE_TYPE.ALL) {
		filtersArray = getADTTotalData(element, patientList, totalForPercentage, ADT_TABLE_TYPE.ALL, TOTAL_TYPE.MAIN);
	}
	if (type === ADT_TABLE_TYPE.ANALYSIS_CHART) {
		let patientListAnalysis = patientList;
		filtersArray = getADTAnalysisChartData(
			element,
			adtTabTableData,
			patientListAnalysis,
			totalForPercentage,
			{
				totalType: TOTAL_TYPE.MAIN,
				intermediateTotals: {},
				currentLevel: 0,
				cardTitles: {}
			}
		);
	}

	if (type === ADT_TABLE_TYPE.DAY_CHART) {
		filtersArray = getADTChartDaysData(element, patientList, totalForPercentage, TOTAL_TYPE.MAIN);
	}

	if (type === ADT_TABLE_TYPE.CHART) {
		filtersArray = getADTChartData(element, patientList, totalForPercentage, TOTAL_TYPE.MAIN);
	}

	if (type === ADT_TABLE_TYPE.GROUP) {
		filtersArray = getADTGroupData(element, patientList, totalForPercentage, TOTAL_TYPE.MAIN);
	}

	if (type === ADT_TABLE_TYPE.GROUP_ARRAY) {
		filtersArray = getADTGroupArrayData(element, patientList, totalForPercentage, TOTAL_TYPE.MAIN);
	}
	return filtersArray;
}
